<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavRight,
    Link,
    Toolbar,
    Block,
    List,
    ListItem,
    Row,
    Col,
    Button,
    AccordionContent,
    Icon,
    MenuItem,
    MenuDropdown,
    MenuDropdownItem,
    Chip,
    Segmented,
    Card,
    CardFooter,
    CardHeader,
    CardContent,
    ListInput,
    Badge,
    Range,
    ListItemCell,
  } from "framework7-svelte";
  import * as moment from "moment";
  import TreeView from "../components/TreeView.svelte";
  import { treeConfig } from "../components/tree/tree-store";
  import { onMount, afterUpdate, onDestroy } from "svelte";
  import {
    mapAction,
    addLayer4,
    addLayerGeneral,
    resizeMap,
    changeFilter,
    addLayerFilter,
    setFilterVisibility,
    setFilterOpacity,
    updateLayerArea,
  } from "../tools/mapboxgl/index";
  import { attributionControl } from "../tools/dom";
  import { layerProperties } from "../components/layer/layer-store";
  import {
    centrar,
    setLayerOpacity,
    deleteDrawPoligon,
    addLayerTvector2,
    addLayerTvector3,
    deleteLayerTvector2,
    deleteLayerTvector3,
    setVectorOpacity,
    deleteIdentify,
    exportFormat
  } from "../tools/mapboxgl/index";
  import { toolsMapInteraction } from "../components/toolsMap/toolsMap-store";
  import { setToolsMap } from "../components/toolsMap/toolsMap-data";
  import { statusInteraction } from "../components/status/status-store";
  import {
    setLayerProperties,
    setLayerProperties2,
    setLayerProperties3,
  } from "../components/layer/layer-data";
  import { setStatus } from "../components/status/status-data";
  import { setDate } from "../components/date/date-data.js";
  import { treeTools } from "../components/tree/tree-store";
  import { setConfigTree, setToolTree } from "../components/tree/tree-data";
  import { layerAtributes } from "../tools/mapboxConfig/layerAtributes";
  import { makePloty } from "../tools/ploty/index";
  import {
    annioBase2,
    annioGrafica,
    paisBase2,
    entidadBase2,
    municipioBase2,
    sensorBase2,
    pcFiltroBase2,
    panelInfo2,
    getPaisTot2,
    getEntTot2,
    getMunTot2,
    storyStatus,
    refPaisImg,
  } from "../stores/storymaps";
  import { mapInterval, mapIntervaltipo } from "../stores/storymaps";
  import {
    onStoryMaps,
    onChangeAnnio,
    onChangePais,
    onChangeEntidad,
    onChangeMunicipio,
    onChangeGrafica,
    onChangeInterval,
    onChangeIntervalTipo,
    onResetStory,
  } from "../tools/storymaps/index";
  import { draggable } from "svelte-drag";
  import AdminExport from "../components/export/AdminExport.svelte";
  import InfoMenu from "../components/infoComp/infoMenu.svelte";
  import { symbology } from "../tools/mapboxConfig/symbology";
  import TableBbox from "../components/infoTable/TableBbox.svelte";
  import { getDateMosaico } from "../tools/service/dates";

  function onOpacityChange(value, opacityName) {
    setLayerOpacity(opacityName, value / 100);
    setLayerProperties3(opacityName, "opacity", value);
  }
  function handlePageResize(node) {
    resizeMap();
    innerWidth = node.srcElement.innerWidth;
    responsive = innerWidth <= 960 ? false : true;
    innerHeight = node.srcElement.innerHeight;

    if (innerHeight <= 773) {
      innerHeightBase = `${innerHeight - 220}`;
    }
    setToolsMap("toolsMeasure", false);
    deleteDrawPoligon();
    $toolsMapInteraction[0]["typeMeasure"] = "";
  }
  function formatDate(value) {
    let month = "" + (value.getMonth() + 1),
      day = "" + value.getDate(),
      year = value.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/");
  }
  function getYears() {
    let yearIni = "1999";
    let yearEnd = moment().format("YYYY");
    let yearAll = [];
    do {
      yearIni = moment(`${yearIni}-01-01`).add(1, "year").format("YYYY");
      yearAll.push(parseInt(yearIni));
    } while (parseInt(yearIni) < parseInt(yearEnd));
    return yearAll;
  }
  onMount(() => {
    setToolsMap("goLongitud", 0);
    setToolsMap("goLatitud", 0);
    resizeMap();
    window.addEventListener("resize", () => {
      resizeMap();
    });
  });
  function menuHeightList(idList, status) {
    let acoordion;
    if (status) {
      accordionOpen = idList;
    }
    if (temas === "consulta") {
      acoordion = 128;
    } else if (temas === "descargas") {
      acoordion = 148;
    } else {
      acoordion = 294;
    }
    let list = parseInt(
      document.querySelector(`#${idList} .list`).offsetHeight
    );

    let total2 = innerHeight - 220;

    if (status) {

      scroll = "hidden";
      if (list + acoordion > innerHeight - 220) {

        setTimeout(function () {
          innerHeightBase = total2;
          scroll = "auto";
        }, 20);
      } else {
        setTimeout(function () {

          innerHeightBase = list + acoordion;
        }, 10);
      }
    } else {
      if (accordionOpen === idList) {
        setTimeout(function () {
          scroll = "hidden";
          innerHeightBase = acoordion;
        }, 200);
      }

    }
    return;
  }
  afterUpdate(() => {
    if (container.querySelector(".mapboxgl-ctrl-top-left") !== null) {
      container.querySelector(".mapboxgl-ctrl-top-left").style.visibility =
        $toolsMapInteraction[0]["toolsMeasure"] ? "visible" : "hidden";
    }
  });

  let container;
  let temas = "temas";
  let adminOpacity;
  let dateIni = new Date();
  let pickerDateIni = [moment().subtract(1, "days")];
  let dateEnd = new Date();
  let pickerDateEnd = [moment().subtract(1, "days")];
  let layerFilter = false;
  let tree;

  let accordionOpen = "";
  $: responsive = innerWidth <= 960 ? false : true;
  let innerWidth;
  let innerHeight;
  $: menuPaisRight = innerWidth <= 960 ? "60px" : "160px";
  $: innerHeightBase =
    accordionOpen === "" && temas == "temas"
      ? 294
      : temas == "consulta"
      ? 98
      : temas == "descargas"
      ? 148
      : innerHeight - 220;
  $: scroll = "hidden";

  let pageDiv;
  let selectedInfo = "hotspots/puntosCalor";
  let selectedYear = moment().format("YYYY");
  let selectedMonth = moment().format("MM");

  let paisFiltro = "México,flag_mexico";
  let notification = false;
  let statusNotification = true;
  let toolsGeneral = {
    drawPolygon: false,
    infoTable: false,
    centrar: false,
    identify: false,
  };
  let dateMosaicos = {
    modis: "",
    modis_true: "",
    modis_false: "",
    viirs: "",
    viirs_true: "",
    viirs_false: "",
    viirsNight: "",
    goes: "",
    m_mh: "",
    m_veg: "",
    winds: "",
    g_glm: "",
    g_rain: "",
    g_mh: "",
    gbbepx: "",
    gbbepx_24h: "",
    pressure: "",
    lightningcast: "",
    goes_aod: "",
  };
  let toolsAnalisis = false;
  let accordionOpened = {
    analisis: false,
  };
  let msgTest = "";
  let leyendControl = true;
  let yearGroup = getYears();

  treeConfig.subscribe((prop) => {
    tree = prop[0];
  });
  layerProperties.subscribe((prop) => {
    adminOpacity = prop;
  });
  onDestroy();

</script>

<svelte:window on:resize={handlePageResize} bind:innerHeight bind:innerWidth />

<div bind:this={pageDiv}>
  <Page name="home" themeDark style="padding-bottom: 0px;">
    <!-- Top Navbar -->
    <Navbar sliding={false}>
      {#if responsive}
        <NavTitle sliding={false} style="margin-left: 0px;margin-right: 0px;">
          {#if innerWidth > 490}
            <img
              src="static/png/conabio_logo.png"
              style="float: left;margin-left: 5px;margin-top: 4px;margin-right: 10px;{innerWidth <
              1162
                ? 'padding-top:13px;'
                : ''}"
              alt="Conabio"
              width="50"
              height="50"
            />
          {/if}
          <p style="float: left;color:var(--f7-tabbar-link-inactive-color);">
            {@html innerWidth > 1162
              ? "Sistema de Alerta Temprana de Incendios Forestales (SATIF)"
              : `Sistema de Alerta Temprana</br>de Incendios Forestales (SATIF)`}
          </p>
        </NavTitle>
        <NavRight>
          <InfoMenu />
        </NavRight>
        <!--<NavRight>
      <Link popoverOpen=".popover-menu">
      <NavTitle sliding>Avisos</NavTitle></Link>
      <Link popupOpen=".demo-popup-contacto"><NavTitle sliding>Contacto</NavTitle></Link>
      <Link popupOpen=".demo-popup-acerca"><NavTitle sliding>Información del sistema</NavTitle></Link>
    </NavRight>-->
      {:else}
        <NavLeft>
          <Link
            iconIos="f7:menu"
            iconAurora="f7:menu"
            iconMd="material:menu"
            panelOpen="left"
          />
        </NavLeft>
        <NavTitle sliding style="margin-left: 0px;margin-right: 0px;">
          <img
            src="static/png/conabio_logo.png"
            style="float: left;margin-left: 5px;margin-top: 8px;margin-right: 10px;padding-top: {innerWidth <
            490
              ? innerWidth < 370
                ? innerWidth < 342
                  ? '12'
                  : '2'
                : '0'
              : '9'}px;"
            alt="Conabio"
            width={innerWidth < 490 ? (innerWidth < 370 ? 40 : 50) : 50}
            height={innerWidth < 490 ? (innerWidth < 370 ? 40 : 50) : 50}
          />
          <p
            style="float: left;color:var(--f7-tabbar-link-inactive-color);{innerWidth <
            490
              ? innerWidth < 380
                ? 'font-size:13px;'
                : 'font-size:15px;'
              : ''}"
          >
            {@html innerWidth > 342
              ? "Sistema de Alerta Temprana</br>de Incendios Forestales (SATIF)"
              : `<h2>SATIF</h2>`}
          </p>
        </NavTitle>
        <NavRight>
          <Link
            iconIos="f7:layers"
            iconAurora="f7:layers"
            iconMd="material:layers"
            panelOpen="right"
          />
        </NavRight>
      {/if}
    </Navbar>
    <!-- Page content -->
    <!-- Mapbox -->
    <div
      style="height: 100%;width: 100%;padding-top: 0px; padding-bottom: 0px;"
      bind:this={container}
      use:mapAction={{ layer: "matorrales" }}
    />

    {#if $toolsMapInteraction[0]["toolsMeasure"]}
      <div
        use:draggable
        style="display: block;position: absolute;bottom: 180px;top: {responsive
          ? '205'
          : '300'}px;z-index: 1000;opacity: .80;margin-top: 0px;width: 140px;padding-left: 0px;margin-bottom: 0px;height: 50px;padding-right: 0px;left: {responsive
          ? '810'
          : '20'}px;"
      >
        <List style="margin: 0px;font-size: 98%;">
          <div id="state-polygon">
            {#if $toolsMapInteraction[0]["typeMeasure"] === ""}
              <h4
                style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
              >
                selecciona una herramienta<br />(Medición/Selección)
              </h4>
            {/if}
            {#if $toolsMapInteraction[0]["typeMeasure"] === "draw_line_string"}
              <h4
                style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
              >
                Trace una línea para <br />realizar la medición<br />de
                distancia
              </h4>
            {/if}
            {#if $toolsMapInteraction[0]["distanceMeasure"] != 0}
              <h4
                style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
              >
                Medición de <br />distancia
              </h4>
              <p
                style="font-size: 93%;text-align: center;opacity: .70;margin-bottom: 0px;margin-top: 0px"
              >
                {@html $toolsMapInteraction[0]["distanceMeasure"]}
              </p>
            {/if}
            {#if $toolsMapInteraction[0]["typeMeasure"] === "draw_polygon"}
              <h4
                style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
              >
                Trace un polígono <br /> para calcular el área
              </h4>
            {/if}
            {#if $toolsMapInteraction[0]["areaMeasure"] != 0 && $toolsMapInteraction[0]["typeMeasure"] === "simple_select"}
              <Link
                noLinkClass={false}
                style="padding: 0px;bottom: -3px;float: left;left: 4px;top: 6px;"
                on:click={() => {}}
                iconSize="17px"
                iconIos="f7:move"
                iconAurora="f7:move"
                iconMd="f7:move"
              />
              <h4
                style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
              >
                Área del polígono
              </h4>
              <p
                style="font-size: 93%;text-align: center;opacity: .70;margin-bottom: 0px;margin-top: 0px"
              >
                {@html $toolsMapInteraction[0]["areaMeasure"]}
              </p>
              {#if $toolsMapInteraction[0]["countPolygon"] != 0}
                <h4
                  style="font-size: 93%;text-align: center;opacity: .70;margin-top: 0px;margin-bottom: 5px;"
                >
                  Puntos dentro <br />del polígono
                </h4>
                <p
                  style="font-size: 93%;text-align: center;opacity: .70;margin-bottom: 0px;margin-top: 0px"
                >
                  {$toolsMapInteraction[0]["countPolygon"]}
                </p>
                <ListInput
                  style="margin-left: 10px;opacity: .70;"
                  label="Formato"
                  type="select"
                  bind:value={$toolsMapInteraction[0]["fileDownload"]}
                  resizable={true}
                  on:change={async () => {
                    exportFormat();
                  }}
                  inputStyle="text-align: center;font-size: 93%;"
                  placeholder="Selecciona..."
                >
                  <div slot="item-media" style="padding-bottom: 10px;" />
                  <option selected value="csv">csv</option>
                  <option value="txt">txt</option>
                  <option value="kml">kml</option>
                  <option value="geojson">geojson</option>
                </ListInput>
                
                <a
                  style="margin-left: 35px;margin-top: 6px;margin-bottom: 6px;"
                  href={$toolsMapInteraction[0]["downloadPolygon"]}
                  id="export"
                  target="_blank"
                  rel="noreferrer noopener"
                  class="link external"
                  download="puntos_de_calor.{$toolsMapInteraction[0][
                    'fileDownload'
                  ]}">descargar</a
                >
              {/if}
            {/if}
          </div>
        </List>
      </div>
    {/if}
    <!-- legend -->
    {#if $treeTools.find((item) => item.identify === true) !== undefined && responsive}
      <div id="state-identify" class="identify">
        {#if $toolsMapInteraction[0].identifyHtml === ""}
          <h4 style="margin-top: 0px;margin-bottom: 15px;">
            {layerAtributes().find(
              (item) =>
                item.id ===
                $treeTools.find((item) => item.identify === true)["id"]
            )["name"]}
          </h4>
          <p style="margin-bottom: 0px;margin-top: 0px">
            Pasa el puntero sobre el punto/polígono
          </p>
        {/if}
        {@html $toolsMapInteraction[0].identifyHtml}
      </div>
    {/if}
    {#if $statusInteraction[0]["activeLayer"] !== 0}
      <div
        id="state-legend"
        class="legend"
        style="background:var(--f7-list-bg-color);height: {leyendControl
          ? 'auto'
          : '20px'};"
      >
        <!--<p>{$statusInteraction[0]['activeLayer']} {$mapInterval}</p>-->
        {#if leyendControl}
          <Link
            style="padding: 8px;left: 16px;bottom: 8px;float: right;"
            on:click={() => {
              leyendControl = !leyendControl;
            }}
            iconSize="17px"
            iconIos="f7:minus_circle"
            iconAurora="f7:minus_circle"
            iconMd="f7:minus_circle"
          />
        {:else}
          <h4 style="float: left;">Simbología</h4>
          <Link
            style="padding: 8px;left: 16px;bottom: 8px;float: right;"
            on:click={() => {
              leyendControl = !leyendControl;
            }}
            iconSize="17px"
            iconIos="f7:plus_circle"
            iconAurora="f7:plus_circle"
            iconMd="f7:plus_circle"
          />
        {/if}
        {#if $statusInteraction[0]["activeLayer"] != 50 && leyendControl}
          {#each symbology.filter((item) => item.id === $statusInteraction[0]["activeLayer"]) as { id, legendName, legend, gradient, min, max }, i}
            <h4>{@html legendName}</h4>
            {#if gradient}
              <div class="legend-gradient" style="background: linear-gradient(to right, {gradient});" />
              <div class="legend-gradient-labels">
                <div>{@html min}</div>
                <div>{@html max}</div>
              </div>
              {#each legend as { key, color }, i}
                <div><span style="background-color: {color}" />{@html key}</div>
              {/each}
            {:else}
              {#each legend as { key, color }, i}
                <div><span style="background-color: {color}" />{@html key}</div>
              {/each}
            {/if}
          {/each}
        {:else if $mapInterval == 3 && leyendControl}
          {#each symbology.filter((item) => item.id === $statusInteraction[0]["activeLayer"]) as { id, legendName, nivel }, i}
            <h4>{@html legendName}</h4>
            {#each nivel.find((item) => item.id === 3)["legend"] as { key, color }, i}
              <div><span style="background-color: {color}" />{@html key}</div>
            {/each}
          {/each}
        {:else if leyendControl}
          {#each symbology.filter((item) => item.id === $statusInteraction[0]["activeLayer"]) as { id, legendName, nivel }, i}
            <h4>{@html legendName}</h4>
            {#each nivel.find((item) => item.id === 5)["legend"] as { key, color }, i}
              <div><span style="background-color: {color}" />{@html key}</div>
            {/each}
          {/each}
        {/if}
      </div>
    {/if}
    <!-- Toolbar -->
    <Toolbar tabbar position="bottom" hidden={true}>
      {#if !responsive}
        <Link popupOpen=".demo-popup-temas" tabLinkActive>Temas</Link>
        <Link popupOpen=".demo-popup-consulta">Consulta</Link>
        <Link popupOpen=".demo-popup-descarga">Descarga</Link>
      {:else}
        <div>
          <p style="padding: 0 30px;">
            <span>Reportar incendios forestales 800 737 00 00 o 911</span>
            <Link
              tabLinkActive={true}
              style="font-size: 12px;float: right;width: 200px;"
              popupOpen=".demo-popup-sitios">Ligas de interés</Link
            >
          </p>
        </div>
      {/if}
    </Toolbar>
    {#if responsive}
      <Block
        style="display: block;position: absolute;top: 90px;bottom: 0px;z-index: 1000;opacity: 1;margin-top: 0px;padding-left: 0px;margin-bottom: 0px;height: 40px;padding-right: 0px;left: 330px;"
      >
        {#if temas != ""}
          <a
            on:click={() => {
              temas = "";
            }}
            class="link icon-only"
            href="/"
            ><Icon f7="rectangle_stack_fill_badge_minus" />
          </a>
        {:else}
          <a
            on:click={() => {
              temas = "temas";
            }}
            class="link icon-only"
            href="/"
            ><Icon f7="rectangle_stack_fill_badge_plus" />
          </a>
        {/if}
      </Block>
    {/if}
    <Block
      id="toolBar"
      style="display: block;position: absolute;top: 70px;bottom: 0px;z-index: 1000;opacity: 1;margin-top: 0px;padding-left: 0px;margin-bottom: 0px;height: 35px;padding-right: 0px;left: {responsive
        ? '400'
        : '210'}px;background: var(--f7-list-bg-color);opacity: 0.6;padding-left: 10px;padding-right: 10px;"
    >
      <Link
        style="margin-top: 5px;margin-left: 5px;color:{toolsGeneral['centrar']
          ? 'dodgerblue'
          : 'white'}"
        iconSize="21px"
        tooltip="*Acercar a sitio{msgTest}"
        iconIos="f7:scope"
        iconAurora="f7:scope"
        iconMd="f7:scope"
        on:click={() => {
          setToolsMap("centerStatus", !$toolsMapInteraction[0]["centerStatus"]);
          toolsGeneral["centrar"] = toolsGeneral["centrar"] ? false : true;
        }}
      />
      {#if $treeTools.filter((item) => item.selected === true).length !== 0}
        <Link
          style="margin-top: 5px;margin-left: 5px;color:{$toolsMapInteraction[0][
            'toolsMeasure'
          ]
            ? 'dodgerblue'
            : 'white'}"
          iconSize="22px"
          tooltip="Medición y selección"
          iconIos="f7:skew"
          iconAurora="f7:skew"
          iconMd="f7:skew"
          on:click={() => {
            if (!$toolsMapInteraction[0]["toolsMeasure"]) {
              let properties = $treeTools.find(
                (item) => item.identify === true
              );
              if (properties !== undefined) {
                setConfigTree(properties["layer"], "identify", false);
                setToolTree(properties["layer"], "identify", false);
              }
              setToolsMap("toolsMeasure", true);
            } else {
              setToolsMap("toolsMeasure", false);
              $toolsMapInteraction[0]["typeMeasure"] = "";
              deleteDrawPoligon();
            }
            if (pageDiv.querySelector(".mapboxgl-ctrl-top-left") !== null) {
              container.querySelector(
                ".mapboxgl-ctrl-top-left"
              ).style.left = `${responsive ? "324" : "10"}px`;
              container.querySelector(".mapboxgl-ctrl-top-left").style.top = `${
                responsive ? "60" : "120"
              }px`;
              container.querySelector(
                ".mapboxgl-ctrl-top-left"
              ).style.visibility = $toolsMapInteraction[0]["toolsMeasure"]
                ? "visible"
                : "hidden";
              if (pageDiv.querySelector(".mapbox-gl-draw_line") !== null) {
                container
                  .querySelector(
                    ".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_line"
                  )
                  .setAttribute("title", "Medición de distancias");
                container
                  .querySelector(
                    ".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_polygon"
                  )
                  .setAttribute("title", "Selección espacial");
                container
                  .querySelector(
                    ".mapbox-gl-draw_ctrl-draw-btn.mapbox-gl-draw_trash"
                  )
                  .setAttribute("title", "Borrar");
              }
            }
          }}
        />
      {/if}
      <TableBbox />
      {#if $treeTools.find((item) => item.id === 50) !== undefined ? $treeTools.find((item) => item.id === 50)["selected"] : false}
        <Link
          style="margin-top: 5px;margin-left: 5px;color:{!$toolsMapInteraction[0][
            'statusPanels'
          ]
            ? 'white'
            : 'dodgerblue'}"
          iconSize="22px"
          tooltip="Info Totales"
          iconIos="f7:rectangle_3_offgrid"
          iconAurora="f7:rectangle_3_offgrid"
          iconMd="f7:rectangle_3_offgrid"
          on:click={() => {
            setToolsMap(
              "statusPanels",
              !$toolsMapInteraction[0]["statusPanels"]
            );
          }}
        />
        <Link
          style="margin-top: 5px;margin-left: 5px;color:{!$toolsMapInteraction[0][
            'statusPloty'
          ]
            ? 'white'
            : 'dodgerblue'}"
          iconSize="22px"
          tooltip="Gráfica"
          iconIos="f7:graph_square"
          iconAurora="f7:graph_square"
          iconMd="f7:graph_square"
          on:click={() => {
            setToolsMap("statusPloty", !$toolsMapInteraction[0]["statusPloty"]);
          }}
        />
      {/if}
    </Block>
    {#if $treeTools.filter((item) => item.selected === true).length !== 0 && $toolsMapInteraction[0]["toolsMeasure"]}
      {#if $toolsMapInteraction[0]["typeMeasure"] === "draw_polygon" || $toolsMapInteraction[0]["typeMeasure"] === "simple_select"}
        <Block
          style="display: block;position: absolute;top: 110px;bottom: 0px;z-index: 1000;opacity: 1;margin-top: 0px;padding-left: 0px;margin-bottom: 0px;height: 35px;padding-right: 0px;left: 430px;background: var(--f7-list-bg-color);opacity: 0.6;padding-left: 0px;padding-right: 0px;"
        >
          <List style="margin-top:0px;margin-bottom:0px;font-size: 12px;">
            <li class="" style="margin-left: 10px; opacity: 0.7;">
              <div class="item-content item-input item-input-with-value">
                <div class="item-inner">
                  <div style="font-size: 12px;" class="item-title item-label">
                    Filtro/Capas({$treeTools.filter(
                      (item) => item.selected === true
                    ).length})
                  </div>
                  <div class="item-input-wrap input-dropdown">
                    <select
                      bind:value={$toolsMapInteraction[0]["layerMeasure"]}
                      style="text-align: center;font-size: 93%;font-size: 12px;"
                      placeholder="Selecciona..."
                      class="input-with-value"
                      on:change={(e) => {

                        $toolsMapInteraction[0]["layerMeasure"] =
                          e.target.value;
                        updateLayerArea();
                      }}
                    >
                      {#each $treeTools.filter((item) => item.selected === true) as { layer, name }, i}
                        <option class="svelte-1opdz2t" value={layer}
                          >{name}</option
                        >
                      {/each}
                    </select>
                  </div>
                </div>
              </div>
            </li>
          </List>
        </Block>
      {/if}
    {/if}
    {#if $treeTools.find((item) => item.id === 50) !== undefined ? $treeTools.find((item) => item.id === 50)["selected"] : false}
      {#if $toolsMapInteraction[0]["statusPanels"]}
        <Block
          id="infoTotal"
          style="display: block;position: absolute;top: 115px;bottom: 0px;z-index: 1000;opacity: 0.65;margin-top: 0px;width: auto;padding-left: 0px;margin-bottom: 0px;height: 80px;padding-right: 0px;{$paisBase2 !=
          '1'
            ? 'width: 190px;'
            : 'auto;'}right: {menuPaisRight};left:390px;"
        >
          <Row resizable={true}>
            <Col>
              <div
                style="background: var(--f7-list-bg-color);"
                class="widget-body flex-fluid full-width flex-vertical external-html panel-padding-quarter overflow-y-auto overflow-x-hidden"
              >
                {#if $pcFiltroBase2 === "pcalor"}
                  <Icon
                    style="color: dodgerblue;float: left;position: fixed;font-size: 21px;width: 22px;height: 22px;margin-top: 6px;margin-left: 8px;"
                    ios="f7:pin"
                    aurora="f7:pin"
                    md="f7:pin"
                  />
                {/if}
                <p style="text-align:center;margin-bottom: 0px;margin-top: 0px;">
                  <span style="font-size:12px">Puntos de calor Totales</span>
                </p>
                <p
                  style="text-align:center;margin-bottom: 0px;margin-top: 0px;"
                >
                  <span style="color:#ff0000"
                    ><span style="font-size:32px;"
                      >{$panelInfo2["ref1"] === undefined
                        ? "---"
                        : $panelInfo2["ref1"]}</span
                    ></span
                  >
                </p>
                {#if $pcFiltroBase2 === "pcalor"}
                  <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                    <span style="font-size:11px">{$panelInfo2["ref2"]}</span><br
                    /><span style="font-size:12px"
                      ><strong>{$panelInfo2["ref3"]}&nbsp;</strong></span
                    >
                  </p>
                {:else}
                  <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                    <span style="font-size:11px" /><br />
                  </p>
                {/if}
              </div>
            </Col>
            {#if $paisBase2 == "1"}
              <Col>
                <div
                  style="background: var(--f7-list-bg-color);"
                  class="widget-body flex-fluid full-width flex-vertical external-html panel-padding-quarter overflow-y-auto overflow-x-hidden"
                >
                  {#if $pcFiltroBase2 === "forestal"}
                    <Icon
                      style="color: dodgerblue;float: left;position: fixed;font-size: 21px;width: 22px;height: 22px;margin-top: 6px;margin-left: 8px;"
                      ios="f7:pin"
                      aurora="f7:pin"
                      md="f7:pin"
                    />
                  {/if}
                  <p style="text-align:center;margin-bottom: 0px;margin-top: 0px;">
                    <span style="font-size:12px"
                      >P. Calor en Áreas Forestales</span
                    >
                  </p>
                  <p
                    style="text-align:center;margin-bottom: 0px;margin-top: 0px;"
                  >
                    <span style="color:#ffaa00"
                      ><span style="font-size:32px;"
                        >{$panelInfo2["ref5"] === undefined
                          ? "---"
                          : $panelInfo2["ref5"]}</span
                      ></span
                    >
                  </p>
                  {#if $pcFiltroBase2 === "forestal"}
                    <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                      <span style="font-size:11px">{$panelInfo2["ref2"]}</span
                      ><br /><span style="font-size:12px"
                        ><strong>{$panelInfo2["ref3"]}&nbsp;</strong></span
                      >
                    </p>
                  {:else}
                    <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                      <span style="font-size:11px" /><br />
                    </p>
                  {/if}
                </div>
              </Col>
              <!--icon...-->
              <Col>
                <div
                  style="background: var(--f7-list-bg-color);"
                  class="widget-body flex-fluid full-width flex-vertical external-html panel-padding-quarter overflow-y-auto overflow-x-hidden"
                >
                  {#if $pcFiltroBase2 === "anp"}
                    <Icon
                      style="color: dodgerblue;float: left;position: fixed;font-size: 21px;width: 22px;height: 22px;margin-top: 6px;margin-left: 8px;"
                      ios="f7:pin"
                      aurora="f7:pin"
                      md="f7:pin"
                    />
                  {/if}
                  <p style="text-align:center;margin-bottom: 0px;margin-top: 0px;">
                    <span style="font-size:12px">Puntos de calor en ANP</span>
                  </p>
                  <p
                    style="text-align:center;margin-bottom: 0px;margin-top: 0px;"
                  >
                    <span style="color:#38a800"
                      ><span style="font-size:32px;"
                        >{$panelInfo2["ref4"] === undefined
                          ? "---"
                          : $panelInfo2["ref4"]}</span
                      ></span
                    >
                  </p>
                  {#if $pcFiltroBase2 === "anp"}
                    <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                      <span style="font-size:11px">{$panelInfo2["ref2"]}</span
                      ><br /><span style="font-size:12px"
                        ><strong>{$panelInfo2["ref3"]}&nbsp;</strong></span
                      >
                    </p>
                  {:else}
                    <p style="text-align:center;margin-top: 0px;margin-bottom: 0px;">
                      <span style="font-size:11px" /><br />
                    </p>
                  {/if}
                </div>
              </Col>
            {/if}
          </Row>
        </Block>
      {/if}
      {#if $toolsMapInteraction[0]["statusPloty"]}
        <Block
          id="refPlot"
          style="display: block;position: absolute;bottom: 190px;z-index: 1000;opacity: 0.65;margin-top: 0px;width: 550px;padding-left: 0px;margin-bottom: 0px;height: 80px;padding-right: 0px;right: {menuPaisRight};left:339px;"
        >
          <div class="tester" use:makePloty />
        </Block>
      {/if}
    {/if}
    <Block
      id="imgPais"
      style="display: block;position: absolute;top: 70px;bottom: 0px;z-index: 1000;opacity: 0.65;margin-top: 0px;width: auto;padding-left: 0px;margin-bottom: 0px;height: 40px;padding-right: 0px;left:{responsive
        ? '660'
        : '5'}px;"
    >
      <Row resizable={true}>
        <Col width="12">
          <div class="">
            <Chip text={paisFiltro.split(",")[0]}>
              <!-- svelte-ignore a11y-missing-attribute -->
              <img
                style="opacity:0.8;"
                slot="media"
                src="static/png/{paisFiltro.split(',')[1]}.png"
              />
            </Chip>
          </div>
        </Col>
      </Row>
    </Block>
    <Block
      id="filtroPais"
      style="display: block;position: absolute;height: 40px;top: {responsive
        ? '65'
        : '111'}px;;bottom: 0px;z-index: 1000;opacity: 0.8;margin-top: 0px;width: auto;padding-left: 0px;margin-bottom: 0px;padding-right: 0px;left:{responsive
        ? '580'
        : '5'}px;"
    >
      <Row resizable={true}>
        <Col width="10">
          <div class="">
            <MenuItem
              tooltip="Seleccionar país"
              text="País"
              dropdown={true}
              style="opacity: 0.70;width: 70px;"
            >
              <MenuDropdown left>
                <MenuDropdownItem
                  href="#"
                  text="México"
                  on:click={() => {
                    addLayer4(1);
                    paisFiltro = "México,flag_mexico";

                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "1");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="Estados Unidos"
                  on:click={() => {
                    addLayer4(2);
                    paisFiltro = "Estados Unidos,flag_usa";

                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "2");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="Guatemala"
                  on:click={() => {
                    addLayer4(3);
                    paisFiltro = "Guatemala,flag_guatemala";
                    $paisBase2 = 3;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "3");
                    }
                  }}
                />
                <MenuDropdownItem divider />
                <MenuDropdownItem
                  href="#"
                  text="Belice"
                  on:click={() => {
                    addLayer4(4);
                    paisFiltro = "Belice,flag_belize";
                    $paisBase2 = 4;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "4");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="Honduras"
                  on:click={() => {
                    addLayer4(5);
                    paisFiltro = "Honduras,flag_honduras";
                    $paisBase2 = 5;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "5");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="El Salvador"
                  on:click={() => {
                    addLayer4(6);
                    paisFiltro = "El Salvador,flag_elsalvador";
                    $paisBase2 = 6;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "6");
                    }
                  }}
                />
                <MenuDropdownItem divider />
                <MenuDropdownItem
                  href="#"
                  text="Nicaragua"
                  on:click={() => {
                    addLayer4(7);
                    paisFiltro = "Nicaragua,flag_nicaragua";
                    $paisBase2 = 7;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "7");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="Costa Rica"
                  on:click={() => {
                    addLayer4(8);
                    paisFiltro = "Costa Rica,flag_costa_rica";
                    $paisBase2 = 8;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "8");
                    }
                  }}
                />
                <MenuDropdownItem
                  href="#"
                  text="Panáma"
                  on:click={() => {
                    addLayer4(9);
                    paisFiltro = "Panáma,flag_panama";
                    $paisBase2 = 9;
                    if ($statusInteraction[0]["activeLayer"] == 50) {
                      $storyStatus["filter"] = false;
                      setToolsMap("statusMunicipios", false);
                      onResetStory("2026", "9");
                    }
                  }}
                />
              </MenuDropdown>
            </MenuItem>
          </div>
        </Col>
      </Row>
    </Block>
    <Block
      style="display: block;position: absolute;bottom: 90px;z-index: 1000;opacity: .70;margin-top: 0px;width: 30px;padding-left: 0px;margin-bottom: 0px;height: 30px;padding-right: 0px;left: 10px;"
    >
      <List style="margin: 0px;font-size: 98%;">
        <Link
          class="attributionMap"
          style="padding-left: 3px;padding-top: 3px;"
          on:click={() => {
            $toolsMapInteraction[0]["attributionMap"] = $toolsMapInteraction[0][
              "attributionMap"
            ]
              ? false
              : true;
            attributionControl($toolsMapInteraction[0]["attributionMap"]);
          }}
          iconIos="f7:info_circle"
          iconAurora="f7:linfo_circle"
          iconMd="material:info_circle"
        />
      </List>
    </Block>

    {#if $toolsMapInteraction[0]["centerStatus"]}
      <Block
        style="display: block;position: absolute;bottom: {$toolsMapInteraction[0][
          'centerStatus'
        ]
          ? '150'
          : '70'}px;z-index: 1000;opacity: .70;margin-top: 0px;width: 40px;padding-left: 0px;margin-bottom: 0px;height: 50px;padding-right: 0px;left: {responsive
          ? '585'
          : '10'}px;"
      >
        <List style="margin: 0px;font-size: 98%;width: 270px;height: 55px;">
          <ListItem
            style="font-size: 93%"
            title="Centrar Visualización"
            name="demo-checkbox"
          >          
            <Segmented tag="p" style="margin:0px;">
              {#if $toolsMapInteraction[0]["goLongitud"] != 0 && $toolsMapInteraction[0]["goLatitud"] != 0}
                <Button
                  outline
                  style="left: 14px;height: 24px;width: 77px;font-size: 90%;opacity:0.8;"
                  active="false"
                  on:click={() => {
                    centrar({
                      lng: $toolsMapInteraction[0]["goLongitud"],
                      lat: $toolsMapInteraction[0]["goLatitud"],
                      zoom: 10,
                    });
                  }}>Llévame</Button
                >
              {/if}
            </Segmented>
            <Segmented tag="p" style="margin:0px;">
              <Link
                style="padding: 8px;left: 16px;bottom: 8px;"
                on:click={() => {
                  centrar({ lng: null, lat: null });
                  setToolsMap(
                    "centerStatus",
                    !$toolsMapInteraction[0]["centerStatus"]
                  );
                }}
                iconSize="17px"
                iconIos="f7:xmark_circle"
                iconAurora="f7:xmark_circle"
                iconMd="f7:xmark_circle"
              />
            </Segmented>
          </ListItem>
          {#if $toolsMapInteraction[0]["centerStatus"]}
            <Block style="padding: 0px;margin: 0px;">
              <Row noGap>
                <Col width="50">
                  <ListInput
                    label="Longitud"
                    bind:value={$toolsMapInteraction[0]["goLongitud"]}
                    type="text"
                    placeholder="ingresar..."
                    clearButton
                    pattern="^[+-]?\b([0-9]?[0-7]?[0-9](\.\d+)?|180)\b"
                    validate
                    errorMessage="Formato incorecto"
                    onInput={(e) => {
                      function isLongitude(lat) {
                        return isFinite(lat) && Math.abs(lat) <= 180;
                      }
                      if (isLongitude(e.target.value)) {
                        $toolsMapInteraction[0]["goLongitud"] = e.target.value;
                      }
                    }}
                  />
                </Col>
                <Col width="50">
                  <ListInput
                    label="Latitud"
                    bind:value={$toolsMapInteraction[0]["goLatitud"]}
                    type="text"
                    placeholder="ingresar..."
                    clearButton
                    pattern="^[+-]?\b([0-8]?[0-9](\.\d+)?|90)\b"
                    validate
                    errorMessage="Formato incorecto"
                    onInput={(e) => {
                      function isLatitude(lat) {
                        return isFinite(lat) && Math.abs(lat) <= 90;
                      }
                      if (isLatitude(e.target.value)) {
                        $toolsMapInteraction[0]["goLatitud"] = e.target.value;
                      }
                    }}
                  />
                </Col>
              </Row>
            </Block>
          {/if}
        </List>
      </Block>
    {/if}
    {#if responsive}
      <Block
        style="display: block;position: absolute;bottom: 25px;z-index: 1000;opacity: .70;margin-top: 0px;width: 40px;padding-left: 0px;margin-bottom: 0px;height: 50px;padding-right: 0px;left: 340px;"
      >
        <List style="margin: 0px;font-size: 98%;width: 270px;">
          <Block style="padding: 0px;margin: 0px;">
            <Row noGap>
              <Col width="15">
                <Link
                  style="padding: 8px;"
                  tooltip="Click aquí para acercar a sitio específico"
                  on:click={() => {
                    setToolsMap(
                      "centerStatus",
                      !$toolsMapInteraction[0]["centerStatus"]
                    );
                    centrar({ lng: 0, lat: 0 });
                  }}
                  iconSize="16px"
                  iconIos="f7:scope"
                  iconAurora="f7:scope"
                  iconMd="f7:scope"
                />
              </Col>
              <Col width="85" style="margin-top: 4px;">
                <div class="item-title latlong">
                  Lon: {$toolsMapInteraction[0]["longitud"]}, Lat: {$toolsMapInteraction[0][
                    "latitud"
                  ]}
                </div>
              </Col>
            </Row>
          </Block>
        </List>
      </Block>
    {/if}
    <Block
      style="display: block;position: absolute;top: 85px;z-index: 1000;opacity: .70;margin-top: 0px;width: 30px;padding-left: 0px;margin-bottom: 0px;height: 30px;padding-right: 0px;left: 380px;"
    >
      {#if notification}
        {#if statusNotification}
          <Chip
            text="nueva capa en (Mi selección)"
            color="blue"
            mediaBgColor="blue"
            iconIos="f7:plus_circle"
            iconAurora="f7:plus_circle"
            iconMd="material:add_circle"
          />
        {:else}
          <Chip
            text="se elimino la capa de (Mi selección)"
            color="blue"
            mediaBgColor="blue"
            iconIos="f7:minus_circle"
            iconAurora="f7:minus_circle"
            iconMd="material:remove_circle"
          />
        {/if}
      {/if}
    </Block>
    {#if responsive}
      <Block
        style="display: block;position: absolute;top: 220px;bottom: 0px;z-index: 1000;opacity: .70;margin-top: 0px;width: 40px;padding-left: 0px;margin-bottom: 0px;height: 40px;padding-right: 0px;right: 10px;"
      >
        <List style="margin: 0px;font-size: 98%;width: 40px;">
          <Link
            style="padding: 8px;"
            iconIos="f7:layers_alt_fill"
            iconAurora="f7:layers_alt_fill"
            iconMd="material:layers_alt_fill"
            panelOpen="right"
          />
        </List>
      </Block>
      <Block
        id="menuGeneral"
        style="display: block;position: absolute;top: 45px;bottom: 0px;z-index: 1000;opacity: 0.70;margin-top: 0px;width: 332px;padding-left: 0px;margin-bottom: 0px;height: 0px;padding-right: 0px;"
      >
        <Row>
          <Col style="height: 70px;">
            <List inset style="font-size: 98%;margin-bottom: 0px;">
              <Segmented tag="p" style="margin-bottom: 0px;">
                <Button
                  style="font-size: 98%;"
                  outline
                  active={temas === "temas"}
                  onClick={() => {
                    temas = "temas";
                  }}
                  badge="1"
                >
                  {#if temas !== "temas" && $layerProperties.filter((item) => item.group !== "base" && item.group !== "filtro" && item.active).length > 0}
                    <ListItem
                      title="Temas"
                      badgeColor="blue"
                      badge={$layerProperties.filter(
                        (item) => item.group !== "base" && item.active
                      ).length > 0
                        ? $layerProperties.filter(
                            (item) =>
                              item.group !== "base" &&
                              item.group !== "filtro" &&
                              item.active
                          ).length
                        : ""}
                    />
                  {:else}
                    Temas
                  {/if}
                </Button>
                <Button
                  style="font-size: 98%;"
                  outline
                  active={temas === "consulta"}
                  onClick={() => {
                    temas = "consulta";
                  }}
                >
                  {#if temas !== "consulta" && $layerProperties.filter((item) => item.group === "filtro" && item.active).length > 0}
                    <ListItem
                      title="Consulta"
                      badgeColor="blue"
                      badge={$layerProperties.filter(
                        (item) => item.group === "filtro" && item.active
                      ).length > 0
                        ? $layerProperties.filter(
                            (item) => item.group === "filtro" && item.active
                          ).length
                        : ""}
                    />
                  {:else}
                    Consulta
                  {/if}
                  <!-- Consulta -->
                </Button>
                <Button
                  style="font-size: 98%;"
                  outline
                  active={temas === "descargas"}
                  onClick={() => {
                    temas = "descargas";
                  }}>Descargas</Button
                >
              </Segmented>
            </List>
            <div id="menu_prueba" >
              <List  accordionList mediaList inset  id="accordion1" style="margin-bottom: 0px;font-size: 98%;overflow-x: hidden;overflow-y: {scroll};height: {temas === ''?0:innerHeightBase}px;margin-top: 0px;">
              <!-- <List
                accordionList
                mediaList
                inset
                id="accordion1"
                style="margin-bottom: 0px;font-size: 98%;overflow-x: hidden;overflow-y: {scroll};height: auto;margin-top: 0px;max-height: 100vw"
              > -->
                {#if temas === "temas" && toolsAnalisis == true}
                  <Navbar
                    style="font-size: 98%;"
                    on:clickBack={() => {
                      if (toolsAnalisis) {
                        setToolTree("estados", "config", false);
                      }
                      toolsAnalisis = !toolsAnalisis ? true : false;
                      accordionOpened["analisis"] = true;
                      $statusInteraction[0]["togle19"] = false;
                    }}
                    title="Estadísticas"
                    backLink="Back"
                  />
                  <div
                    id="prueba24"
                    style="width: {$treeTools.find((item) => item.id === 50) !==
                    undefined
                      ? $treeTools.find((item) => item.id === 50)['config']
                        ? 'auto'
                        : '0px'
                      : '0px'}; height: {$treeTools.find(
                      (item) => item.id === 50
                    ) !== undefined
                      ? $treeTools.find((item) => item.id === 50)['config']
                        ? 'auto'
                        : '0px'
                      : '0px'};visibility: {$treeTools.find(
                      (item) => item.id === 50
                    ) !== undefined
                      ? $treeTools.find((item) => item.id === 50)['config']
                        ? 'visible'
                        : 'hidden'
                      : 'hidden'}"
                  >
                    <ListItem
                      style="font-size: 93%;"
                      title="Filtros"
                      name="demo-checkbox"
                      divider={false}
                    />
                    <ListItem
                      style="margin-left: 5px;"
                      accordionItem
                      title="General (Año/País/Sensor)"
                    >
                      <AccordionContent>
                        <!--Año-->
                        <ListInput
                          label="Año"
                          type="select"
                          bind:value={$annioBase2}
                          resizable={true}
                          on:change={async () => {
                            $storyStatus["filter"] = true;
                            if (parseInt($annioBase2) < 2013) {
                              $sensorBase2 = "modis";
                            }
                            onChangeAnnio();
                          }}
                          inputStyle="text-align: center;font-size: 93%;"
                          placeholder="Selecciona..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option selected value="2026">2026</option>
                          <option value="2025">2025</option>
                          <option value="2024">2024</option>
                          <option value="2023">2023</option>
                          <option value="2022">2022</option>
                          <option value="2021">2021</option>
                          <option value="2020">2020</option>
                          <option value="2019">2019</option>
                          <option value="2018">2018</option>
                          <option value="2017">2017</option>
                          <option value="2016">2016</option>
                          <option value="2015">2015</option>
                          <option value="2014">2014</option>
                          <option value="2013">2013</option>
                          <option value="2012">2012</option>
                          <option value="2011">2011</option>
                          <option value="2010">2010</option>
                          <option value="2009">2009</option>
                          <option value="2008">2008</option>
                          <option value="2007">2007</option>
                          <option value="2006">2006</option>
                          <option value="2005">2005</option>
                          <option value="2004">2004</option>
                        </ListInput>
                        <!--País-->
                        <ListInput
                          label="País"
                          type="select"
                          resizable={true}
                          bind:value={$paisBase2}
                          on:change={() => {
                            $toolsMapInteraction[0]["nivelAdminFilter"] = 1;
                            if ($paisBase2 != "1") {
                              $pcFiltroBase2 = "pcalor";
                            }
                            let namePais = $refPaisImg.find(
                              (item) => item.id == $paisBase2
                            );
                            paisFiltro = `${namePais["name"]},${namePais["img"]}`;
                            onChangePais();
                            setToolsMap("statusMunicipios", false);
                          }}
                          inputStyle="text-align: center;font-size: 93%;"
                          placeholder="Selecciona..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          {#each $getPaisTot2 as { id_pais, nom_pais, total } (id_pais)}
                            {#if id_pais == $paisBase2}
                              <option value={id_pais} selected
                                >{nom_pais}-{total}</option
                              >
                            {:else}
                              <option value={id_pais}>{nom_pais}-{total}</option
                              >
                            {/if}
                          {/each}
                        </ListInput>
                        <!--Sensor-->
                        <ListInput
                          label=""
                          type="select"
                          bind:value={$sensorBase2}
                          resizable={true}
                          on:change={() => {
                            onChangeAnnio();
                          }}
                          inputStyle="text-align: center;font-size: 93%;"
                          placeholder="Selecciona..."
                        >
                          <div slot="label" style="padding-bottom: 10px;">
                            Sensor
                            <Link
                              style="margin-top: 15px;"
                              iconSize="20px"
                              tooltip={`
                        Los puntos de calor de MODIS y VIIRS se muestran por separado<br>
                        por los cambios en la resolución en la detección (MODIS 1 Km, VIIRS 750 m y 375 m).<br>
                        Haz click para saber más
                        `}
                              iconIos="f7:info_circle_fill"
                              iconAurora="f7:info_circle_fill"
                              iconMd="f7:info_circle_fill"
                              on:click={() => {}}
                            />
                          </div>
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option value="modis">MODIS</option>
                          {#if parseInt($annioBase2) > 2013}
                            <option value="viirs">VIIRS</option>
                          {/if}
                        </ListInput>
                        <!--Filtro P.Calor-->
                        {#if $paisBase2 == "1"}
                          <ListInput
                            label="Filtro Puntos de Calor"
                            type="select"
                            resizable={true}
                            bind:value={$pcFiltroBase2}
                            on:change={() => {
                              onChangeAnnio();
                            }}
                            inputStyle="text-align: center;font-size: 13px;"
                            placeholder="Selecciona..."
                          >
                            <div
                              slot="item-media"
                              style="padding-bottom: 10px;"
                            />
                            <option value="pcalor">Todos</option>
                            {#if $paisBase2 == "1"}
                              <option value="anp">En Anp´s</option>
                              <option value="forestal"
                                >En Áreas Forestales</option
                              >
                            {/if}
                          </ListInput>
                        {/if}
                      </AccordionContent>
                    </ListItem>
                    <ListItem
                      style="margin-left: 5px;"
                      accordionItem
                      title="Administrativo (Entidad/Municipio)"
                    >
                      <AccordionContent>
                        <!--Entidad-->
                        <ListInput
                          label="Entidad"
                          type="select"
                          resizable={true}
                          bind:value={$entidadBase2}
                          on:change={() => {
                            $toolsMapInteraction[0]["nivelAdminFilter"] = 2;
                            setToolsMap("statusMunicipios", true);
                            onChangeEntidad();
                          }}
                          inputStyle="text-align: left;font-size: 93%;"
                          placeholder="Selecciona..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option value=""
                            >Seleccionar...(Estado-Total p.calor)</option
                          >
                          {#each $getEntTot2 as { id_estado, nom_estado, total } (id_estado)}
                            <option value={id_estado}
                              >{nom_estado}-{total}</option
                            >
                          {/each}
                        </ListInput>
                        <!--Municipio-->
                        {#if $toolsMapInteraction[0]["statusMunicipios"]}
                          <ListInput
                            label="Municipio"
                            type="select"
                            resizable={true}
                            bind:value={$municipioBase2}
                            on:change={() => {
                              $toolsMapInteraction[0]["nivelAdminFilter"] = 3;
                              onChangeMunicipio();
                            }}
                            inputStyle="text-align: left;font-size: 93%;"
                            placeholder="Selecciona..."
                          >
                            <div
                              slot="item-media"
                              style="padding-bottom: 10px;"
                            />
                            <option value="">Seleccionar...</option>
                            {#each $getMunTot2 as { id_mun, nom_mun, total } (id_mun)}
                              {#if $municipioBase2 == id_mun}
                                <option value={id_mun} selected
                                  >{nom_mun}-{total}</option
                                >
                              {:else}
                                <option value={id_mun}>{nom_mun}-{total}</option
                                >
                              {/if}
                            {/each}
                          </ListInput>
                        {/if}
                      </AccordionContent>
                    </ListItem>
                    <ListItem
                      style="margin-left: 5px;"
                      accordionItem
                      title="Gráfica (Comparación)"
                    >
                      <AccordionContent>
                        <!--Año de comparación-->
                        <ListInput
                          label="Año de comparación"
                          type="select"
                          bind:value={$annioGrafica}
                          resizable={true}
                          on:change={() => {
                            onChangeGrafica();
                          }}
                          inputStyle="text-align: center;font-size: 13px;"
                          placeholder="Selecciona..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option value="2025">2025</option>
                          <option value="2024">2024</option>
                          <option value="2023">2023</option>
                          <option value="2022">2022</option>
                          <option value="2021" selected>2021</option>
                          <option value="2020">2020</option>
                          <option value="2019">2019</option>
                          <option value="2018">2018</option>
                          <option value="2017">2017</option>
                          <option value="2016">2016</option>
                          <option value="2015">2015</option>
                          <option value="2014">2014</option>
                          <option value="2013">2013</option>
                          <option value="2012">2012</option>
                          <option value="2011">2011</option>
                          <option value="2010">2010</option>
                          <option value="2009">2009</option>
                          <option value="2008">2008</option>
                          <option value="2007">2007</option>
                          <option value="2006">2006</option>
                          <option value="2005">2005</option>
                          <option value="2004">2004</option>
                        </ListInput>
                        <!--Municipio-->
                      </AccordionContent>
                    </ListItem>
                    <ListItem
                      style="margin-left: 5px;"
                      accordionItem
                      title="Mapa (Clasificación/Intervalos)"
                    >
                      <AccordionContent>
                        <!--Tipo de clasificación-->
                        <ListInput
                          label="Tipo de clasificación"
                          type="select"
                          resizable={true}
                          bind:value={$mapIntervaltipo}
                          on:change={() => {
                            onChangeIntervalTipo();
                          }}
                          inputStyle="text-align: center;font-size: 12px;"
                          placeholder="Selecciona..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option value="1">Intervalos Iguales</option>
                          <option value="2">Cuantiles</option>
                          <option value="3">Cortes Naturales</option>
                        </ListInput>
                        <!--Intervalos-->
                        <ListInput
                          label="Intervalos"
                          type="select"
                          resizable={true}
                          bind:value={$mapInterval}
                          on:change={() => {
                            onChangeInterval();
                          }}
                          inputStyle="text-align: center;font-size: 13px;"
                          placeholder="Seleccionar..."
                        >
                          <div
                            slot="item-media"
                            style="padding-bottom: 10px;"
                          />
                          <option value="3">3</option>
                          <option value="5">5</option>
                        </ListInput>
                      </AccordionContent>
                    </ListItem>
                    <ListItem
                      style="font-size: 93%;padding-left: 10px;"
                      title="Transparencia"
                      name="demo-checkbox"
                    />
                    <ListItem style="left: 30px;">
                      <Row noGap>
                        <Col width="10">
                          <ListItemCell class="width-auto">
                            <Icon
                              size="21px"
                              ios="f7:sun_min"
                              aurora="f7:sun_min"
                              md="f7:sun_min"
                            />
                          </ListItemCell>
                        </Col>
                        <Col width="60">
                          <ListItemCell>
                            <Range
                              min={0}
                              max={100}
                              step={1}
                              value={100}
                              label={true}
                              onRangeChange={(val) => {
                                setVectorOpacity("estados", val / 100);
                              }}
                            />
                          </ListItemCell>
                        </Col>
                        <Col width="15">
                          <ListItemCell class="width-auto flex-shrink-0">
                            <Icon
                              size="21px"
                              ios="f7:sun_max_fill"
                              aurora="f7:sun_max_fill"
                              md="f7:sun_max_fill"
                            />
                          </ListItemCell>
                        </Col>
                      </Row>
                    </ListItem>
                  </div>
                {/if}
                {#if temas === "temas" && toolsAnalisis == false}
                  <ListItem
                    selected
                    class="badgeAlerta"
                    accordionItem
                    on:accordionOpen={async () => {
                      menuHeightList("alerta", true);
                      let services = [
                        getDateMosaico({ name: "m_mh" }),
                        getDateMosaico({ name: "m_veg" }),
                        getDateMosaico({ name: "winds" }),
                        getDateMosaico({ name: "g_glm" }),
                        getDateMosaico({ name: "g_rain" }),
                        getDateMosaico({ name: "g_mh" }),
                        getDateMosaico({ name: "lightningcast" }),
                      ];
                      let getInfo = await Promise.allSettled(services);
                      let m_mh = getInfo[0]["value"];
                      let m_veg = getInfo[1]["value"];
                      let winds = getInfo[2]["value"];
                      let g_glm = getInfo[3]["value"];
                      let g_rain = getInfo[4]["value"];
                      let g_mh = getInfo[5]["value"];
                      let lightningcast = getInfo[6]["value"];

                      dateMosaicos["g_mh"] = moment(
                        g_mh["date"]
                      ).format("DD-MM-YYYY");

                      dateMosaicos["m_mh"] = moment(
                        m_mh["date"]
                      ).format("DD-MM-YYYY");

                      dateMosaicos["m_veg"] = moment(
                        m_veg["date"]
                      ).format("DD-MM-YYYY");

                      dateMosaicos["winds"] = moment(
                        winds["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");

                      dateMosaicos["g_glm"] = moment(
                        g_glm["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");

                      dateMosaicos["g_rain"] = moment(
                        g_rain["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");

                      dateMosaicos["lightningcast"] = moment(
                        lightningcast["date"]
                      ).format("YYYY-MM-DD HH:mm:ss");
                    }}
                    on:accordionClose={() => {
                      menuHeightList("alerta", false);
                    }}
                  >
                    <div slot="title">Alerta</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$layerProperties.filter(
                          (item) => item.subgrupo === 'alerta' && item.active
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$layerProperties.filter(
                          (item) => item.subgrupo === "alerta" && item.active
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="alerta">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <!--Modelo de humedad-->
                        <ListItem
                          style="font-size: 93%"
                          title="MODIS"
                          name="demo-checkbox"
                        />
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 10;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(10);
                                  setLayerProperties(10);
                                  setStatus("togle10", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 10
                                )["active"]}
                              >
                                <div slot="title">
                                  Modelo de humedad<br />de 100 hrs (MH100h) <br />{dateMosaicos["m_mh"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle10"] && adminOpacity.find((item) => item.id === 10)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 10
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 10);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 10)["active"]}
                                {#if $statusInteraction[0]["togle10"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(10, "myselect");
                                      setStatus("togle10", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(10, "myselect");
                                      setStatus("togle10", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Anomalías de la vegetación-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 11;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(11);
                                  setLayerProperties(11);
                                  setStatus("togle11", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 11
                                )["active"]}
                              >
                                <div slot="title">
                                  Anomalías de la vegetación <br />{dateMosaicos["m_veg"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 11)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 11
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 11);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 11)["active"]}
                                {#if $statusInteraction[0]["togle11"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(11, "myselect");
                                      setStatus("togle11", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(11, "myselect");
                                      setStatus("togle11", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>

                        <ListItem
                          style="font-size: 93%"
                          title="GOES"
                          name="demo-checkbox"
                        />

                   <!-- GOES MH-->
                   <Block style="padding: 0px;">
                    <Row noGap>
                      <Col width="85">
                        <ListItem
                          checkbox
                          name="demo-checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              $statusInteraction[0]["activeLayer"] = 103;
                            } else {
                              $statusInteraction[0]["activeLayer"] = 0;
                            }
                          }}
                          on:change={() => {
                            addLayerGeneral(103);
                            setLayerProperties(103);
                            setStatus("togle11", false);
                          }}
                          checked={adminOpacity.find(
                            (item) => item.id === 103
                          )["active"]}
                        >
                          <div slot="title">
                            GOES - MH100h <br />(preliminar) <br />{dateMosaicos["g_mh"]}
                          </div>
                          <div slot="root">
                            {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 103)["active"]}
                              <ListItem style="left: 30px;">
                                <Row noGap>
                                  <Col width="10">
                                    <ListItemCell class="width-auto">
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_min"
                                        aurora="f7:sun_min"
                                        md="f7:sun_min"
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="60">
                                    <ListItemCell>
                                      <Range
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={$layerProperties.find(
                                          (item) => item.id === 103
                                        )["opacity"]}
                                        label={true}
                                        onRangeChange={(val) => {
                                          onOpacityChange(val, 103);
                                        }}
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="15">
                                    <ListItemCell
                                      class="width-auto flex-shrink-0"
                                    >
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_max_fill"
                                        aurora="f7:sun_max_fill"
                                        md="f7:sun_max_fill"
                                      />
                                    </ListItemCell>
                                  </Col>
                                </Row>
                              </ListItem>
                            {/if}
                          </div>
                        </ListItem>
                      </Col>
                      <Col width="15">
                        {#if adminOpacity.find((item) => item.id === 103)["active"]}
                          {#if $statusInteraction[0]["togle11"]}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt_fill"
                              iconAurora="f7:gear_alt_fill"
                              iconMd="f7:gear_alt_fill"
                              on:click={() => {
                                setLayerProperties2(103, "myselect");
                                setStatus("togle11", false);
                              }}
                            />
                          {:else}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt"
                              iconAurora="f7:gear_alt"
                              iconMd="f7:gear_alt"
                              on:click={() => {
                                setLayerProperties2(103, "myselect");
                                setStatus("togle11", true);
                              }}
                            />
                          {/if}
                        {/if}
                      </Col>
                    </Row>
                  </Block>
                  <!-- GOES MH-->

                  <!-- GOES MH QA-->
                  <Block style="padding: 0px;">
                    <Row noGap>
                      <Col width="85">
                        <ListItem
                          checkbox
                          name="demo-checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              $statusInteraction[0]["activeLayer"] = 104;
                            } else {
                              $statusInteraction[0]["activeLayer"] = 0;
                            }
                          }}
                          on:change={() => {
                            addLayerGeneral(104);
                            setLayerProperties(104);
                            setStatus("togle11", false);
                          }}
                          checked={adminOpacity.find(
                            (item) => item.id === 104
                          )["active"]}
                        >
                          <div slot="title">
                            GOES - MH100h QA <br />(preliminar)<br />{dateMosaicos["g_mh"]}
                          </div>
                          <div slot="root">
                            {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 104)["active"]}
                              <ListItem style="left: 30px;">
                                <Row noGap>
                                  <Col width="10">
                                    <ListItemCell class="width-auto">
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_min"
                                        aurora="f7:sun_min"
                                        md="f7:sun_min"
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="60">
                                    <ListItemCell>
                                      <Range
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={$layerProperties.find(
                                          (item) => item.id === 104
                                        )["opacity"]}
                                        label={true}
                                        onRangeChange={(val) => {
                                          onOpacityChange(val, 104);
                                        }}
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="15">
                                    <ListItemCell
                                      class="width-auto flex-shrink-0"
                                    >
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_max_fill"
                                        aurora="f7:sun_max_fill"
                                        md="f7:sun_max_fill"
                                      />
                                    </ListItemCell>
                                  </Col>
                                </Row>
                              </ListItem>
                            {/if}
                          </div>
                        </ListItem>
                      </Col>
                      <Col width="15">
                        {#if adminOpacity.find((item) => item.id === 104)["active"]}
                          {#if $statusInteraction[0]["togle11"]}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt_fill"
                              iconAurora="f7:gear_alt_fill"
                              iconMd="f7:gear_alt_fill"
                              on:click={() => {
                                setLayerProperties2(104, "myselect");
                                setStatus("togle11", false);
                              }}
                            />
                          {:else}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt"
                              iconAurora="f7:gear_alt"
                              iconMd="f7:gear_alt"
                              on:click={() => {
                                setLayerProperties2(104, "myselect");
                                setStatus("togle11", true);
                              }}
                            />
                          {/if}
                        {/if}
                      </Col>
                    </Row>
                  </Block>
                  <!-- GOES MH QA-->


                   <!-- GOES Wind-->
                   <Block style="padding: 0px;">
                    <Row noGap>
                      <Col width="85">
                        <ListItem
                          checkbox
                          name="demo-checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              $statusInteraction[0]["activeLayer"] = 100;
                            } else {
                              $statusInteraction[0]["activeLayer"] = 0;
                            }
                          }}
                          on:change={() => {
                            addLayerGeneral(100);
                            setLayerProperties(100);
                            setStatus("togle11", false);
                          }}
                          checked={adminOpacity.find(
                            (item) => item.id === 100
                          )["active"]}
                        >
                          <div slot="title">
                            GOES - Vientos <br />{dateMosaicos["winds"]}
                          </div>
                          <div slot="root">
                            {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 100)["active"]}
                              <ListItem style="left: 30px;">
                                <Row noGap>
                                  <Col width="10">
                                    <ListItemCell class="width-auto">
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_min"
                                        aurora="f7:sun_min"
                                        md="f7:sun_min"
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="60">
                                    <ListItemCell>
                                      <Range
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={$layerProperties.find(
                                          (item) => item.id === 100
                                        )["opacity"]}
                                        label={true}
                                        onRangeChange={(val) => {
                                          onOpacityChange(val, 100);
                                        }}
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="15">
                                    <ListItemCell
                                      class="width-auto flex-shrink-0"
                                    >
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_max_fill"
                                        aurora="f7:sun_max_fill"
                                        md="f7:sun_max_fill"
                                      />
                                    </ListItemCell>
                                  </Col>
                                </Row>
                              </ListItem>
                            {/if}
                          </div>
                        </ListItem>
                      </Col>
                      <Col width="15">
                        {#if adminOpacity.find((item) => item.id === 100)["active"]}
                          {#if $statusInteraction[0]["togle11"]}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt_fill"
                              iconAurora="f7:gear_alt_fill"
                              iconMd="f7:gear_alt_fill"
                              on:click={() => {
                                setLayerProperties2(100, "myselect");
                                setStatus("togle11", false);
                              }}
                            />
                          {:else}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt"
                              iconAurora="f7:gear_alt"
                              iconMd="f7:gear_alt"
                              on:click={() => {
                                setLayerProperties2(100, "myselect");
                                setStatus("togle11", true);
                              }}
                            />
                          {/if}
                        {/if}
                      </Col>
                    </Row>
                  </Block>
                  <!-- GOES Wind-->

                  <!-- Pronostico de rayos 1h (lightningcast)-->
                  <Block style="padding: 0px;">
                    <Row noGap>
                      <Col width="85">
                        <ListItem
                          checkbox
                          name="demo-checkbox"
                          onChange={(e) => {
                            if (e.target.checked) {
                              $statusInteraction[0]["activeLayer"] = 130;
                            } else {
                              $statusInteraction[0]["activeLayer"] = 0;
                            }
                          }}
                          on:change={() => {
                            addLayerGeneral(130);
                            setLayerProperties(130);
                            setStatus("togle130", false);
                          }}
                          checked={adminOpacity.find(
                            (item) => item.id === 130
                          )["active"]}
                        >
                          <div slot="title">
                            GOES - Pronóstico de rayos<br /> (1h) <br />{dateMosaicos["lightningcast"]}
                          </div>
                          <div slot="root">
                            {#if $statusInteraction[0]["togle130"] && adminOpacity.find((item) => item.id === 130)["active"]}
                              <ListItem style="left: 30px;">
                                <Row noGap>
                                  <Col width="10">
                                    <ListItemCell class="width-auto">
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_min"
                                        aurora="f7:sun_min"
                                        md="f7:sun_min"
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="60">
                                    <ListItemCell>
                                      <Range
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={$layerProperties.find(
                                          (item) => item.id === 130
                                        )["opacity"]}
                                        label={true}
                                        onRangeChange={(val) => {
                                          onOpacityChange(val, 130);
                                        }}
                                      />
                                    </ListItemCell>
                                  </Col>
                                  <Col width="15">
                                    <ListItemCell
                                      class="width-auto flex-shrink-0"
                                    >
                                      <Icon
                                        size="21px"
                                        ios="f7:sun_max_fill"
                                        aurora="f7:sun_max_fill"
                                        md="f7:sun_max_fill"
                                      />
                                    </ListItemCell>
                                  </Col>
                                </Row>
                              </ListItem>
                            {/if}
                          </div>
                        </ListItem>
                      </Col>
                      <Col width="15">
                        {#if adminOpacity.find((item) => item.id === 130)["active"]}
                          {#if $statusInteraction[0]["togle130"]}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt_fill"
                              iconAurora="f7:gear_alt_fill"
                              iconMd="f7:gear_alt_fill"
                              on:click={() => {
                                setLayerProperties2(130, "myselect");
                                setStatus("togle130", false);
                              }}
                            />
                          {:else}
                            <Link
                              style="margin-top: 15px;"
                              iconSize="21px"
                              tooltip="Configurar capa"
                              iconIos="f7:gear_alt"
                              iconAurora="f7:gear_alt"
                              iconMd="f7:gear_alt"
                              on:click={() => {
                                setLayerProperties2(130, "myselect");
                                setStatus("togle130", true);
                              }}
                            />
                          {/if}
                        {/if}
                      </Col>
                    </Row>
                  </Block>

                                     <!-- GOES GLM-->
                                     <Block style="padding: 0px;">
                                      <Row noGap>
                                        <Col width="85">
                                          <ListItem
                                            checkbox
                                            name="demo-checkbox"
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                $statusInteraction[0]["activeLayer"] = 101;
                                              } else {
                                                $statusInteraction[0]["activeLayer"] = 0;
                                              }
                                            }}
                                            on:change={() => {
                                              addLayerGeneral(101);
                                              setLayerProperties(101);
                                              setStatus("togle11", false);
                                            }}
                                            checked={adminOpacity.find(
                                              (item) => item.id === 101
                                            )["active"]}
                                          >
                                            <div slot="title">
                                              GOES - Rayos <br />{dateMosaicos["g_glm"]}
                                            </div>
                                            <div slot="root">
                                              {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 101)["active"]}
                                                <ListItem style="left: 30px;">
                                                  <Row noGap>
                                                    <Col width="10">
                                                      <ListItemCell class="width-auto">
                                                        <Icon
                                                          size="21px"
                                                          ios="f7:sun_min"
                                                          aurora="f7:sun_min"
                                                          md="f7:sun_min"
                                                        />
                                                      </ListItemCell>
                                                    </Col>
                                                    <Col width="60">
                                                      <ListItemCell>
                                                        <Range
                                                          min={0}
                                                          max={100}
                                                          step={1}
                                                          value={$layerProperties.find(
                                                            (item) => item.id === 101
                                                          )["opacity"]}
                                                          label={true}
                                                          onRangeChange={(val) => {
                                                            onOpacityChange(val, 101);
                                                          }}
                                                        />
                                                      </ListItemCell>
                                                    </Col>
                                                    <Col width="15">
                                                      <ListItemCell
                                                        class="width-auto flex-shrink-0"
                                                      >
                                                        <Icon
                                                          size="21px"
                                                          ios="f7:sun_max_fill"
                                                          aurora="f7:sun_max_fill"
                                                          md="f7:sun_max_fill"
                                                        />
                                                      </ListItemCell>
                                                    </Col>
                                                  </Row>
                                                </ListItem>
                                              {/if}
                                            </div>
                                          </ListItem>
                                        </Col>
                                        <Col width="15">
                                          {#if adminOpacity.find((item) => item.id === 101)["active"]}
                                            {#if $statusInteraction[0]["togle11"]}
                                              <Link
                                                style="margin-top: 15px;"
                                                iconSize="21px"
                                                tooltip="Configurar capa"
                                                iconIos="f7:gear_alt_fill"
                                                iconAurora="f7:gear_alt_fill"
                                                iconMd="f7:gear_alt_fill"
                                                on:click={() => {
                                                  setLayerProperties2(101, "myselect");
                                                  setStatus("togle11", false);
                                                }}
                                              />
                                            {:else}
                                              <Link
                                                style="margin-top: 15px;"
                                                iconSize="21px"
                                                tooltip="Configurar capa"
                                                iconIos="f7:gear_alt"
                                                iconAurora="f7:gear_alt"
                                                iconMd="f7:gear_alt"
                                                on:click={() => {
                                                  setLayerProperties2(101, "myselect");
                                                  setStatus("togle11", true);
                                                }}
                                              />
                                            {/if}
                                          {/if}
                                        </Col>
                                      </Row>
                                    </Block>
                                    <!-- GOES GLM-->

<!-- GOES Rain-->
<Block style="padding: 0px;">
  <Row noGap>
    <Col width="85">
      <ListItem
        checkbox
        name="demo-checkbox"
        onChange={(e) => {
          if (e.target.checked) {
            $statusInteraction[0]["activeLayer"] = 102;
          } else {
            $statusInteraction[0]["activeLayer"] = 0;
          }
        }}
        on:change={() => {
          addLayerGeneral(102);
          setLayerProperties(102);
          setStatus("togle11", false);
        }}
        checked={adminOpacity.find(
          (item) => item.id === 102
        )["active"]}
      >
        <div slot="title">
          GOES - Precipitación <br />{dateMosaicos["g_rain"]}
        </div>
        <div slot="root">
          {#if $statusInteraction[0]["togle11"] && adminOpacity.find((item) => item.id === 102)["active"]}
            <ListItem style="left: 30px;">
              <Row noGap>
                <Col width="10">
                  <ListItemCell class="width-auto">
                    <Icon
                      size="21px"
                      ios="f7:sun_min"
                      aurora="f7:sun_min"
                      md="f7:sun_min"
                    />
                  </ListItemCell>
                </Col>
                <Col width="60">
                  <ListItemCell>
                    <Range
                      min={0}
                      max={100}
                      step={1}
                      value={$layerProperties.find(
                        (item) => item.id === 102
                      )["opacity"]}
                      label={true}
                      onRangeChange={(val) => {
                        onOpacityChange(val, 102);
                      }}
                    />
                  </ListItemCell>
                </Col>
                <Col width="15">
                  <ListItemCell
                    class="width-auto flex-shrink-0"
                  >
                    <Icon
                      size="21px"
                      ios="f7:sun_max_fill"
                      aurora="f7:sun_max_fill"
                      md="f7:sun_max_fill"
                    />
                  </ListItemCell>
                </Col>
              </Row>
            </ListItem>
          {/if}
        </div>
      </ListItem>
    </Col>
    <Col width="15">
      {#if adminOpacity.find((item) => item.id === 102)["active"]}
        {#if $statusInteraction[0]["togle11"]}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt_fill"
            iconAurora="f7:gear_alt_fill"
            iconMd="f7:gear_alt_fill"
            on:click={() => {
              setLayerProperties2(102, "myselect");
              setStatus("togle11", false);
            }}
          />
        {:else}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt"
            iconAurora="f7:gear_alt"
            iconMd="f7:gear_alt"
            on:click={() => {
              setLayerProperties2(102, "myselect");
              setStatus("togle11", true);
            }}
          />
        {/if}
      {/if}
    </Col>
  </Row>
</Block>
<!-- GOES Rain-->

                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    class="badgePcalor"
                    accordionItem
                    on:accordionOpen={() => {
                      menuHeightList("pcalor", true);
                    }}
                    on:accordionClose={() => {
                      menuHeightList("pcalor", false);
                    }}
                  >
                    <div slot="title">Puntos de calor</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$layerProperties.filter(
                          (item) => item.subgrupo === 'pcalor' && item.active
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$layerProperties.filter(
                          (item) => item.subgrupo === "pcalor" && item.active
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="pcalor">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <ListItem
                          style="font-size: 93%"
                          title="MODIS-VIIRS"
                          name="demo-checkbox"
                        />
                        <!--puntos de calor-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "pcalordia",
                                      4,
                                      "pcalorBase"
                                    );
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 4;
                                    setLayerProperties3(4, "active", true);
                                  } else {
                                    deleteLayerTvector2("pcalordia");
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(4, "active", false);
                                  }
                                }}
                                on:change={() => {
                                  /*addLayerGeneral(4)
                                setLayerProperties(4)
                                setStatus('togle4',false)
                                identify(4)
                                */
                                }}
                                checked={$treeTools.find(
                                  (item) => item.id === 4
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 4)[
                                      "selected"
                                    ]
                                    ? true
                                    : false
                                  : false}
                              >
                                <div slot="title">
                                  Puntos de calor <br />
                                  {moment().format(
                                    "DD/MM/YYYY"
                                  )}<!--{`${formatDate(dateIni)}`}-->
                                </div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 4) !== undefined ? $treeTools.find((item) => item.id === 4)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 4)["config"]}
                                      <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
                                      <List
                                        style="font-size: 93%;margin-left: 15px;"
                                      >
                                        <!--<ListItem checkbox title="Seleccionar todos" name="demo-checkbox"
                                    on:change={()=>{addLayer4(null);paisFiltro='Todos,flag_general'}}
                                    ></ListItem>
                                    <ListItem checkbox title="México" name="demo-checkbox" checked
                                    on:change={()=>{addLayer4(1);paisFiltro='México,flag_mexico'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Estados Unidos" name="demo-checkbox"
                                    on:change={()=>{addLayer4(2);paisFiltro='Estados Unidos,flag_usa'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Guatemala" name="demo-checkbox"
                                    on:change={()=>{addLayer4(3);paisFiltro='Guatemala,flag_guatemala'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Belize" name="demo-checkbox"
                                    on:change={()=>{addLayer4(4);paisFiltro='Belice,flag_belize'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Honduras" name="demo-checkbox"
                                    on:change={()=>{addLayer4(5);paisFiltro='Honduras,flag_honduras'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Salvador" name="demo-checkbox"
                                    on:change={()=>{addLayer4(6);paisFiltro='El Salvador,flag_elsalvador'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Panamá" name="demo-checkbox"
                                    on:change={()=>{addLayer4(7);paisFiltro='Nicaragua,flag_nicaragua'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Costa Rica" name="demo-checkbox"
                                    on:change={()=>{addLayer4(8);paisFiltro='Costa Rica,flag_costa_rica'}}
                                    ></ListItem>
                                    <ListItem checkbox title="Panáma" name="demo-checkbox"
                                    on:change={()=>{addLayer4(9);paisFiltro='Panáma,flag_panama'}}
                                    ></ListItem>-->
                                      </List>
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={100}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  setVectorOpacity(
                                                    "pcalordia",
                                                    val / 100
                                                  );
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>

                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 4) !== undefined ? $treeTools.find((item) => item.id === 4)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 4)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "pcalordia",
                                        "identify",
                                        false
                                      );
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "pcalordia",
                                        "identify",
                                        true
                                      );
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 4) !== undefined ? $treeTools.find((item) => item.id === 4)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 4)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("pcalordia", "config", false);

                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("pcalordia", "config", true);

                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Clúster de puntos-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 5;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(5);
                                  setLayerProperties(5);
                                  setStatus("togle5", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 5
                                )["active"]}
                              >
                                <div slot="title">
                                  Clúster de puntos <br />de calor (48h)
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle5"] && adminOpacity.find((item) => item.id === 5)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              iconSize="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 5
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 5);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              iconSize="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 5)["active"]}
                                {#if $statusInteraction[0]["togle5"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(5, "myselect");
                                      setStatus("togle5", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(5, "myselect");
                                      setStatus("togle5", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Puntos estables-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                on:change={() => {
                                  addLayerGeneral(6);
                                  setLayerProperties(6);
                                  setStatus("togle6", false);
                                }}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 6;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 6
                                )["active"]}
                              >
                                <div slot="title">Puntos estables</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle6"] && adminOpacity.find((item) => item.id === 6)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              iconSize="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 6
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 6);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              iconSize="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 6)["active"]}
                                {#if $statusInteraction[0]["togle6"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(6, "myselect");
                                      setStatus("togle6", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(6, "myselect");
                                      setStatus("togle6", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <ListItem
                          style="font-size: 93%"
                          title="GOES(ABI) LANOT"
                          name="demo-checkbox"
                        />
                        <!--P.Calor última hora-->
                        <Block style="padding: 0px;">

                          <!--puntos de calor GOES 10 min-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "goes_points",
                                      105,
                                      "pcalorBase"
                                    );
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 105;
                                    setLayerProperties3(105, "active", true);
                                  } else {
                                    deleteLayerTvector2("goes_points");
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(105, "active", false);
                                  }
                                }}
                                on:change={() => {
                                }}
                                checked={$treeTools.find(
                                  (item) => item.id === 105
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 105)[
                                      "selected"
                                    ]
                                    ? true
                                    : false
                                  : false}
                              >
                                <div slot="title">
                                  Puntos de calor <br />(últimos 10 mins) <br />
                                  {moment().format(
                                    "DD/MM/YYYY"
                                  )}<!--{`${formatDate(dateIni)}`}-->
                                </div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 105) !== undefined ? $treeTools.find((item) => item.id === 105)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 105)["config"]}
                                      <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
                                      <List
                                        style="font-size: 93%;margin-left: 15px;"
                                      >
                                      </List>
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={100}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  setVectorOpacity(
                                                    "goes_points",
                                                    val / 100
                                                  );
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>

                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 105) !== undefined ? $treeTools.find((item) => item.id === 105)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 105)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "goes_points",
                                        "identify",
                                        false
                                      );
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "goes_points",
                                        "identify",
                                        true
                                      );
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 105) !== undefined ? $treeTools.find((item) => item.id === 105)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 105)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("goes_points", "config", false);

                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("goes_points", "config", true);

                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                          <!--puntos de calor GOES 10 min-->

                          <!--puntos de calor GOES 24 Hrs-->
                          <Block style="padding: 0px;">
                            <Row noGap>
                              <Col width="75">
                                <ListItem
                                  checkbox
                                  name="demo-checkbox"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      addLayerTvector2(
                                        "goes_heatmap",
                                        107,
                                        "pcalorBase"
                                      );
                                      addLayerTvector2(
                                        "goes_heatmap_points",
                                        106,
                                        "pcalorBase"
                                      );
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 106;
                                      setLayerProperties3(106, "active", true);
                                    } else {
                                      deleteLayerTvector2("goes_heatmap_points");
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 0;
                                      setLayerProperties3(106, "active", false);
                                      deleteLayerTvector2("goes_heatmap");
                                    }
                                  }}
                                  on:change={() => {
                                  }}
                                  checked={$treeTools.find(
                                    (item) => item.id === 106
                                  ) !== undefined
                                    ? $treeTools.find((item) => item.id === 106)[
                                        "selected"
                                      ]
                                      ? true
                                      : false
                                    : false}
                                >
                                  <div slot="title">
                                    Puntos de calor <br />(últimas 24Hrs) <br />
                                    {moment().format(
                                      "DD/MM/YYYY"
                                    )}<!--{`${formatDate(dateIni)}`}-->
                                  </div>
                                  <div slot="root">
                                    {#if $treeTools.find((item) => item.id === 106) !== undefined ? $treeTools.find((item) => item.id === 106)["selected"] : false}
                                      {#if $treeTools.find((item) => item.id === 106)["config"]}
                                        <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
                                        <List
                                          style="font-size: 93%;margin-left: 15px;"
                                        >
                                        </List>
                                        <ListItem style="left: 30px;">
                                          <Row noGap>
                                            <Col width="10">
                                              <ListItemCell class="width-auto">
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_min"
                                                  aurora="f7:sun_min"
                                                  md="f7:sun_min"
                                                />
                                              </ListItemCell>
                                            </Col>
                                            <Col width="60">
                                              <ListItemCell>
                                                <Range
                                                  min={0}
                                                  max={100}
                                                  step={1}
                                                  value={100}
                                                  label={true}
                                                  onRangeChange={(val) => {
                                                    setVectorOpacity(
                                                      "goes_heatmap_points",
                                                      val / 100
                                                    );
                                                  }}
                                                />
                                              </ListItemCell>
                                            </Col>
  
                                            <Col width="15">
                                              <ListItemCell
                                                class="width-auto flex-shrink-0"
                                              >
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_max_fill"
                                                  aurora="f7:sun_max_fill"
                                                  md="f7:sun_max_fill"
                                                />
                                              </ListItemCell>
                                            </Col>
                                          </Row>
                                        </ListItem>
                                      {/if}
                                    {/if}
                                  </div>
                                </ListItem>
                              </Col>
                              <Col width="10">
                                {#if $treeTools.find((item) => item.id === 106) !== undefined ? $treeTools.find((item) => item.id === 106)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 106)["identify"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle_fill"
                                      iconAurora="f7:info_circle_fill"
                                      iconMd="f7:info_circle_fill"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "goes_heatmap_points",
                                          "identify",
                                          false
                                        );
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle"
                                      iconAurora="f7:info_circle"
                                      iconMd="f7:info_circle"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "goes_heatmap_points",
                                          "identify",
                                          true
                                        );
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                              <Col width="15">
                                {#if $treeTools.find((item) => item.id === 106) !== undefined ? $treeTools.find((item) => item.id === 106)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 106)["config"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt_fill"
                                      iconAurora="f7:gear_alt_fill"
                                      iconMd="f7:gear_alt_fill"
                                      on:click={() => {
                                        setToolTree("goes_heatmap_points", "config", false);
  
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt"
                                      iconAurora="f7:gear_alt"
                                      iconMd="f7:gear_alt"
                                      on:click={() => {
                                        setToolTree("goes_heatmap_points", "config", true);
  
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                            </Row>
                          </Block>
                            <!--puntos de calor GOES 24 Hrs-->

                            <ListItem
                            style="font-size: 93%"
                            title="GOES(ABI) NOAA"
                            name="demo-checkbox"
                          />

                          
                          <!--puntos de calor GOES FDCF 10 min-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "goes_fdcf_10min",
                                      108,
                                      "pcalorBase"
                                    );
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 108;
                                    setLayerProperties3(108, "active", true);
                                  } else {
                                    deleteLayerTvector2("goes_fdcf_10min");
                                    deleteIdentify();
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(108, "active", false);
                                  }
                                }}
                                on:change={() => {
                                }}
                                checked={$treeTools.find(
                                  (item) => item.id === 108
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 108)[
                                      "selected"
                                    ]
                                    ? true
                                    : false
                                  : false}
                              >
                                <div slot="title">
                                  Puntos de calor<br />(últimos 10 mins) <br />
                                  {moment().format(
                                    "DD/MM/YYYY"
                                  )}<!--{`${formatDate(dateIni)}`}-->
                                </div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 108) !== undefined ? $treeTools.find((item) => item.id === 108)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 108)["config"]}
                                      <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
                                      <List
                                        style="font-size: 93%;margin-left: 15px;"
                                      >
                                      </List>
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={100}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  setVectorOpacity(
                                                    "goes_fdcf_10min",
                                                    val / 100
                                                  );
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>

                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                iconSize="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 108) !== undefined ? $treeTools.find((item) => item.id === 108)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 108)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "goes_fdcf_10min",
                                        "identify",
                                        false
                                      );
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree(
                                        "goes_fdcf_10min",
                                        "identify",
                                        true
                                      );
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 108) !== undefined ? $treeTools.find((item) => item.id === 108)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 108)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("goes_fdcf_10min", "config", false);

                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("goes_fdcf_10min", "config", true);

                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                          <!--puntos de calor GOES FDCF 10 min-->  


                          <!--puntos de calor GOES FDCF 24 Hrs-->
                          <Block style="padding: 0px;">
                            <Row noGap>
                              <Col width="75">
                                <ListItem
                                  checkbox
                                  name="demo-checkbox"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      addLayerTvector2(
                                        "goes_fdcf_heatmap",
                                        110,
                                        "pcalorBase"
                                      );
                                      addLayerTvector2(
                                        "goes_fdcf_heatmap_points",
                                        109,
                                        "pcalorBase"
                                      );
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 109;
                                      setLayerProperties3(109, "active", true);
                                    } else {
                                      deleteLayerTvector2("goes_fdcf_heatmap_points");
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 0;
                                      setLayerProperties3(109, "active", false);
                                      deleteLayerTvector2("goes_fdcf_heatmap");
                                    }
                                  }}
                                  on:change={() => {
                                  }}
                                  checked={$treeTools.find(
                                    (item) => item.id === 109
                                  ) !== undefined
                                    ? $treeTools.find((item) => item.id === 109)[
                                        "selected"
                                      ]
                                      ? true
                                      : false
                                    : false}
                                >
                                  <div slot="title">
                                    Puntos de calor <br />(últimas 24Hrs) <br />
                                    {moment().format(
                                      "DD/MM/YYYY"
                                    )}<!--{`${formatDate(dateIni)}`}-->
                                  </div>
                                  <div slot="root">
                                    {#if $treeTools.find((item) => item.id === 109) !== undefined ? $treeTools.find((item) => item.id === 109)["selected"] : false}
                                      {#if $treeTools.find((item) => item.id === 109)["config"]}
                                        <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
                                        <List
                                          style="font-size: 93%;margin-left: 15px;"
                                        >
                                        </List>
                                        <ListItem style="left: 30px;">
                                          <Row noGap>
                                            <Col width="10">
                                              <ListItemCell class="width-auto">
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_min"
                                                  aurora="f7:sun_min"
                                                  md="f7:sun_min"
                                                />
                                              </ListItemCell>
                                            </Col>
                                            <Col width="60">
                                              <ListItemCell>
                                                <Range
                                                  min={0}
                                                  max={100}
                                                  step={1}
                                                  value={100}
                                                  label={true}
                                                  onRangeChange={(val) => {
                                                    setVectorOpacity(
                                                      "goes_fdcf_heatmap_points",
                                                      val / 100
                                                    );
                                                  }}
                                                />
                                              </ListItemCell>
                                            </Col>
  
                                            <Col width="15">
                                              <ListItemCell
                                                class="width-auto flex-shrink-0"
                                              >
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_max_fill"
                                                  aurora="f7:sun_max_fill"
                                                  md="f7:sun_max_fill"
                                                />
                                              </ListItemCell>
                                            </Col>
                                          </Row>
                                        </ListItem>
                                      {/if}
                                    {/if}
                                  </div>
                                </ListItem>
                              </Col>
                              <Col width="10">
                                {#if $treeTools.find((item) => item.id === 109) !== undefined ? $treeTools.find((item) => item.id === 109)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 109)["identify"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle_fill"
                                      iconAurora="f7:info_circle_fill"
                                      iconMd="f7:info_circle_fill"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "goes_fdcf_heatmap_points",
                                          "identify",
                                          false
                                        );
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle"
                                      iconAurora="f7:info_circle"
                                      iconMd="f7:info_circle"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "goes_fdcf_heatmap_points",
                                          "identify",
                                          true
                                        );
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                              <Col width="15">
                                {#if $treeTools.find((item) => item.id === 109) !== undefined ? $treeTools.find((item) => item.id === 109)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 109)["config"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt_fill"
                                      iconAurora="f7:gear_alt_fill"
                                      iconMd="f7:gear_alt_fill"
                                      on:click={() => {
                                        setToolTree("goes_fdcf_heatmap_points", "config", false);
  
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt"
                                      iconAurora="f7:gear_alt"
                                      iconMd="f7:gear_alt"
                                      on:click={() => {
                                        setToolTree("goes_fdcf_heatmap_points", "config", true);
  
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                            </Row>
                          </Block>
                            <!--puntos de calor GOES FDCF 24 Hrs-->





                        </Block>
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    class="badgeMosaicos"
                    accordionItem
                    on:accordionOpen={async () => {
                      menuHeightList("mosaicos", true);
                      let services = [
                        getDateMosaico({ name: "modis" }),
                        getDateMosaico({ name: "modis_true" }),
                        getDateMosaico({ name: "modis_false" }),
                        getDateMosaico({ name: "v_d" }),
                        getDateMosaico({ name: "v_true" }),
                        getDateMosaico({ name: "v_false" }),
                        getDateMosaico({ name: "v_n" }),
                        getDateMosaico({ name: "goes" }),
                      ];
                      let getInfo = await Promise.allSettled(services);
                      let modis = getInfo[0]["value"];
                      let modis_true = getInfo[1]["value"];
                      let modis_false = getInfo[2]["value"];
                      let virrs = getInfo[3]["value"];
                      let virrs_true = getInfo[4]["value"];
                      let virrs_false = getInfo[5]["value"];
                      let viirsNight = getInfo[6]["value"];
                      let goes = getInfo[7]["value"];

                      dateMosaicos["modis"] = moment(
                        modis["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["modis_true"] = moment(
                        modis_true["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["modis_false"] = moment(
                        modis_false["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["v_d"] = moment(
                        virrs["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["v_true"] = moment(
                        virrs_true["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["v_false"] = moment(
                        virrs_false["date"]
                        ).format("DD-MM-YYYY");
                      dateMosaicos["v_n"] = moment(
                        viirsNight["date"]
                      ).format("DD-MM-YYYY");
                      dateMosaicos["goes"] = moment(
                        goes["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");

                    }}
                    on:accordionClose={() => {
                      menuHeightList("mosaicos", false);
                    }}
                  >
                    <div slot="title">Mosaicos</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$layerProperties.filter(
                          (item) => item.subgrupo === 'mosaicos' && item.active
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$layerProperties.filter(
                          (item) => item.subgrupo === "mosaicos" && item.active
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="mosaicos">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <ListItem
                          style="font-size: 93%"
                          title="MODIS"
                          name="demo-checkbox"
                        />
                        <!--Falso color-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 12;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(12);
                                  setLayerProperties(12);
                                  setStatus("togle12", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 12
                                )["active"]}
                              >
                                <div slot="title">
                                  Falso color <br />{dateMosaicos["modis_false"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle12"] && adminOpacity.find((item) => item.id === 12)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 12
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 12);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 12)["active"]}
                                {#if $statusInteraction[0]["togle12"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(12, "myselect");
                                      setStatus("togle12", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(12, "myselect");
                                      setStatus("togle12", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--color verdadero-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 26;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(26);
                                  setLayerProperties(26);
                                  setStatus("togle26", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 26
                                )["active"]}
                              >
                                <div slot="title">
                                  Color verdadero<br />{dateMosaicos["modis_true"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle26"] && adminOpacity.find((item) => item.id === 26)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 26
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 26);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 26)["active"]}
                                {#if $statusInteraction[0]["togle26"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(26, "myselect");
                                      setStatus("togle26", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(26, "myselect");
                                      setStatus("togle26", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <ListItem
                          style="font-size: 93%"
                          title="VIIRS"
                          name="demo-checkbox"
                        />
                        <!--Falso color-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 13;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(13);
                                  setLayerProperties(13);
                                  setStatus("togle13", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 13
                                )["active"]}
                              >
                                <div slot="title">
                                  Falso color<br />{dateMosaicos["v_false"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle13"] && adminOpacity.find((item) => item.id === 13)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 13
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 13);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 13)["active"]}
                                {#if $statusInteraction[0]["togle13"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(13, "myselect");
                                      setStatus("togle13", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(13, "myselect");
                                      setStatus("togle13", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Color verdadero-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 14;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(14);
                                  setLayerProperties(14);
                                  setStatus("togle14", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 14
                                )["active"]}
                              >
                                <div slot="title">
                                  Color verdadero<br />{dateMosaicos["v_true"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle14"] && adminOpacity.find((item) => item.id === 14)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 14
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 14);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 14)["active"]}
                                {#if $statusInteraction[0]["togle14"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(14, "myselect");
                                      setStatus("togle14", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(14, "myselect");
                                      setStatus("togle14", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Nocturno-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 28;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(28);
                                  setLayerProperties(28);
                                  setStatus("togle28", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 28
                                )["active"]}
                              >
                                <div slot="title">
                                  Nocturno<br />{dateMosaicos["v_n"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle28"] && adminOpacity.find((item) => item.id === 28)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 28
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 28);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 28)["active"]}
                                {#if $statusInteraction[0]["togle28"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(28, "myselect");
                                      setStatus("togle28", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(28, "myselect");
                                      setStatus("togle28", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <ListItem
                          style="font-size: 93%"
                          title="GOES"
                          name="demo-checkbox"
                        />
                        <!--Falso color-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 36;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(36);
                                  setLayerProperties(36);
                                  setStatus("togle36", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 36
                                )["active"]}
                              >
                                <div slot="title">
                                  Falso color<br />{dateMosaicos["goes"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle36"] && adminOpacity.find((item) => item.id === 36)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 36
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 36);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 36)["active"]}
                                {#if $statusInteraction[0]["togle36"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(36, "myselect");
                                      setStatus("togle36", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(36, "myselect");
                                      setStatus("togle36", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Color verdadero-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 37;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(37);
                                  setLayerProperties(37);
                                  setStatus("togle37", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 37
                                )["active"]}
                              >
                                <div slot="title">
                                  Color verdadero<br />{dateMosaicos["goes"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle37"] && adminOpacity.find((item) => item.id === 37)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 37
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 37);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 37)["active"]}
                                {#if $statusInteraction[0]["togle37"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(37, "myselect");
                                      setStatus("togle37", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(37, "myselect");
                                      setStatus("togle37", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    class="badgeAquemadas"
                    accordionItem
                    on:accordionOpen={async () => {
                      menuHeightList("aquemadas", true);
                      let services = [
                        getDateMosaico({ name: "gbbepx" }),
                        getDateMosaico({ name: "goes_aod" }),
                      ];
                      let getInfo = await Promise.allSettled(services);
                      let gbbepx = getInfo[0]["value"];
                      let goes_aod = getInfo[1]["value"];

                      dateMosaicos["gbbepx"] = moment(
                        gbbepx["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");
                      dateMosaicos["gbbepx_24h"] = moment(
                        gbbepx["date"]
                      ).format("DD-MM-YYYY");
                      dateMosaicos["goes_aod"] = moment(
                        goes_aod["date"]
                      ).format("DD-MM-YYYY HH:mm:ss");
                    }}
                    on:accordionClose={() => {
                      menuHeightList("aquemadas", false);
                    }}
                  >
                    <div slot="title">Áreas quemadas y Emisiones</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$layerProperties.filter(
                          (item) => item.subgrupo === 'aquemadas' && item.active
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$layerProperties.filter(
                          (item) => item.subgrupo === "aquemadas" && item.active
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="aquemadas">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <ListItem
                        style="font-size: 93%"
                        title="Áreas quemadas (AQ)"
                        name="demo-checkbox"
                      />
                      <!--AQ LAST MODIS MONTHLY (vector tile / GeoServer MVT)-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "aqmodis_outline",
                                      89,
                                      "complementaria"
                                    );
                                    addLayerTvector2(
                                      "aqmodis",
                                      88,
                                      "complementaria"
                                    );
                                    $statusInteraction[0]["activeLayer"] = 88;
                                    setLayerProperties3(88, "active", true);
                                  } else {
                                    deleteLayerTvector2("aqmodis");
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(88, "active", false);
                                    deleteLayerTvector2("aqmodis_outline");
                                  }
                                }}
                                on:change={() => {}}
                                checked={$treeTools.find(
                                  (item) => item.id === 88
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 88)[
                                      "selected"
                                    ]
                                  : false}
                              >
                                <div slot="title">AQ MODIS <br /> Febrero 2026</div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 88)["config"]}
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={$layerProperties.find(
                                                  (item) => item.id === 88
                                                )["opacity"]}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  onOpacityChange(val, 88);
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 88)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("aqmodis", "identify", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("aqmodis", "identify", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 88)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("aqmodis", "config", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("aqmodis", "config", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--AQ MODIS 2025 -->
                        <!-- <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "aqmodis_outline",
                                      89,
                                      "complementaria"
                                    );
                                    addLayerTvector2(
                                      "aqmodis",
                                      88,
                                      "complementaria"
                                    );
                                    $statusInteraction[0]["activeLayer"] = 88;
                                    setLayerProperties3(88, "active", true);
                                  } else {
                                    deleteLayerTvector2("aqmodis");
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(88, "active", false);
                                    deleteLayerTvector2("aqmodis_outline");
                                  }
                                }}
                                on:change={() => {}}
                                checked={$treeTools.find(
                                  (item) => item.id === 88
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 88)[
                                      "selected"
                                    ]
                                  : false}
                              >
                                <div slot="title">
                                  AQ MODIS vector tile <br /> Septiembre 2025
                                </div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 88)["config"]}
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={$layerProperties.find(
                                                  (item) => item.id === 88
                                                )["opacity"]}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  onOpacityChange(val, 88);
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 88)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("aqmodis", "identify", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("aqmodis", "identify", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 88) !== undefined ? $treeTools.find((item) => item.id === 88)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 88)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("aqmodis", "config", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("aqmodis", "config", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block> -->

                        <!--AQ 2000-2019 México-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 16;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(16);
                                  setLayerProperties(16);
                                  setStatus("togle16", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 16
                                )["active"]}
                              >
                                <div slot="title">AQ 2001-2024 México</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle16"] && adminOpacity.find((item) => item.id === 16)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 16
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 16);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 16)["active"]}
                                {#if $statusInteraction[0]["togle16"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(16, "myselect");
                                      setStatus("togle16", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(16, "myselect");
                                      setStatus("togle16", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--AQ 2000-2019 CA-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 17;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(17);
                                  setLayerProperties(17);
                                  setStatus("togle17", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 17
                                )["active"]}
                              >
                                <div slot="title">AQ 2001-2024 CA</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle17"] && adminOpacity.find((item) => item.id === 17)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 17
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 17);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 17)["active"]}
                                {#if $statusInteraction[0]["togle17"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(17, "myselect");
                                      setStatus("togle17", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(17, "myselect");
                                      setStatus("togle17", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <ListItem
                        style="font-size: 93%"
                        title="Emisiones RAVE (GOES-VIIRS) NOAA"
                        name="demo-checkbox"
                      />
                      <!-- Emisiones -->
<!--RAVE points-->
<Block style="padding: 0px;">
  <Row noGap>
    <Col width="75">
      <ListItem
        checkbox
        name="demo-checkbox"
        onChange={(e) => {
          if (e.target.checked) {
            addLayerTvector2(
              "rave",
              120,
              "pcalorBase"
            );
            deleteIdentify();
            $statusInteraction[0]["activeLayer"] = 120;
            setLayerProperties3(120, "active", true);
          } else {
            deleteLayerTvector2("rave");
            deleteIdentify();
            $statusInteraction[0]["activeLayer"] = 0;
            setLayerProperties3(120, "active", false);
          }
        }}
        on:change={() => {
        }}
        checked={$treeTools.find(
          (item) => item.id === 120
        ) !== undefined
          ? $treeTools.find((item) => item.id === 120)[
              "selected"
            ]
            ? true
            : false
          : false}
      >
        <div slot="title">
          RAVE 3km (Última Obs.) <br />
          {dateMosaicos["gbbepx"]}<!--{`${formatDate(dateIni)}`}-->
        </div>
        <div slot="root">
          {#if $treeTools.find((item) => item.id === 120) !== undefined ? $treeTools.find((item) => item.id === 120)["selected"] : false}
            {#if $treeTools.find((item) => item.id === 120)["config"]}
              <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
              <List
                style="font-size: 93%;margin-left: 15px;"
              >
              </List>
              <ListItem style="left: 30px;">
                <Row noGap>
                  <Col width="10">
                    <ListItemCell class="width-auto">
                      <Icon
                        iconSize="21px"
                        ios="f7:sun_min"
                        aurora="f7:sun_min"
                        md="f7:sun_min"
                      />
                    </ListItemCell>
                  </Col>
                  <Col width="60">
                    <ListItemCell>
                      <Range
                        min={0}
                        max={100}
                        step={1}
                        value={100}
                        label={true}
                        onRangeChange={(val) => {
                          setVectorOpacity(
                            "rave",
                            val / 100
                          );
                        }}
                      />
                    </ListItemCell>
                  </Col>

                  <Col width="15">
                    <ListItemCell
                      class="width-auto flex-shrink-0"
                    >
                      <Icon
                        iconSize="21px"
                        ios="f7:sun_max_fill"
                        aurora="f7:sun_max_fill"
                        md="f7:sun_max_fill"
                      />
                    </ListItemCell>
                  </Col>
                </Row>
              </ListItem>
            {/if}
          {/if}
        </div>
      </ListItem>
    </Col>
    <Col width="10">
      {#if $treeTools.find((item) => item.id === 120) !== undefined ? $treeTools.find((item) => item.id === 120)["selected"] : false}
        {#if $treeTools.find((item) => item.id === 120)["identify"]}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Identificar objetos espaciales"
            iconIos="f7:info_circle_fill"
            iconAurora="f7:info_circle_fill"
            iconMd="f7:info_circle_fill"
            on:click={() => {
              deleteIdentify();
              setToolTree(
                "rave",
                "identify",
                false
              );
            }}
          />
        {:else}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Identificar objetos espaciales"
            iconIos="f7:info_circle"
            iconAurora="f7:info_circle"
            iconMd="f7:info_circle"
            on:click={() => {
              deleteIdentify();
              setToolTree(
                "rave",
                "identify",
                true
              );
            }}
          />
        {/if}
      {/if}
    </Col>
    <Col width="15">
      {#if $treeTools.find((item) => item.id === 120) !== undefined ? $treeTools.find((item) => item.id === 120)["selected"] : false}
        {#if $treeTools.find((item) => item.id === 120)["config"]}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt_fill"
            iconAurora="f7:gear_alt_fill"
            iconMd="f7:gear_alt_fill"
            on:click={() => {
              setToolTree("rave", "config", false);

            }}
          />
        {:else}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt"
            iconAurora="f7:gear_alt"
            iconMd="f7:gear_alt"
            on:click={() => {
              setToolTree("rave", "config", true);

            }}
          />
        {/if}
      {/if}
    </Col>
  </Row>
</Block>
<!--RAVE points-->

<!--RAVE 24h points-->
<Block style="padding: 0px;">
  <Row noGap>
    <Col width="75">
      <ListItem
        checkbox
        name="demo-checkbox"
        onChange={(e) => {
          if (e.target.checked) {
            addLayerTvector2(
              "rave_24h",
              121,
              "pcalorBase"
            );
            deleteIdentify();
            $statusInteraction[0]["activeLayer"] = 121;
            setLayerProperties3(121, "active", true);
          } else {
            deleteLayerTvector2("rave_24h");
            deleteIdentify();
            $statusInteraction[0]["activeLayer"] = 0;
            setLayerProperties3(121, "active", false);
          }
        }}
        on:change={() => {
        }}
        checked={$treeTools.find(
          (item) => item.id === 121
        ) !== undefined
          ? $treeTools.find((item) => item.id === 121)[
              "selected"
            ]
            ? true
            : false
          : false}
      >
        <div slot="title">
          RAVE 3km 24Hrs<br />
          {dateMosaicos["gbbepx_24h"]}<!--{`${formatDate(dateIni)}`}-->
        </div>
        <div slot="root">
          {#if $treeTools.find((item) => item.id === 121) !== undefined ? $treeTools.find((item) => item.id === 121)["selected"] : false}
            {#if $treeTools.find((item) => item.id === 121)["config"]}
              <!--<p style="margin-left: 30px;margin-top: 0px;margin-bottom: 0px;">País</p>-->
              <List
                style="font-size: 93%;margin-left: 15px;"
              >
              </List>
              <ListItem style="left: 30px;">
                <Row noGap>
                  <Col width="10">
                    <ListItemCell class="width-auto">
                      <Icon
                        iconSize="21px"
                        ios="f7:sun_min"
                        aurora="f7:sun_min"
                        md="f7:sun_min"
                      />
                    </ListItemCell>
                  </Col>
                  <Col width="60">
                    <ListItemCell>
                      <Range
                        min={0}
                        max={100}
                        step={1}
                        value={100}
                        label={true}
                        onRangeChange={(val) => {
                          setVectorOpacity(
                            "rave_24h",
                            val / 100
                          );
                        }}
                      />
                    </ListItemCell>
                  </Col>

                  <Col width="15">
                    <ListItemCell
                      class="width-auto flex-shrink-0"
                    >
                      <Icon
                        iconSize="21px"
                        ios="f7:sun_max_fill"
                        aurora="f7:sun_max_fill"
                        md="f7:sun_max_fill"
                      />
                    </ListItemCell>
                  </Col>
                </Row>
              </ListItem>
            {/if}
          {/if}
        </div>
      </ListItem>
    </Col>
    <Col width="10">
      {#if $treeTools.find((item) => item.id === 121) !== undefined ? $treeTools.find((item) => item.id === 121)["selected"] : false}
        {#if $treeTools.find((item) => item.id === 121)["identify"]}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Identificar objetos espaciales"
            iconIos="f7:info_circle_fill"
            iconAurora="f7:info_circle_fill"
            iconMd="f7:info_circle_fill"
            on:click={() => {
              deleteIdentify();
              setToolTree(
                "rave_24h",
                "identify",
                false
              );
            }}
          />
        {:else}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Identificar objetos espaciales"
            iconIos="f7:info_circle"
            iconAurora="f7:info_circle"
            iconMd="f7:info_circle"
            on:click={() => {
              deleteIdentify();
              setToolTree(
                "rave_24h",
                "identify",
                true
              );
            }}
          />
        {/if}
      {/if}
    </Col>
    <Col width="15">
      {#if $treeTools.find((item) => item.id === 121) !== undefined ? $treeTools.find((item) => item.id === 121)["selected"] : false}
        {#if $treeTools.find((item) => item.id === 121)["config"]}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt_fill"
            iconAurora="f7:gear_alt_fill"
            iconMd="f7:gear_alt_fill"
            on:click={() => {
              setToolTree("rave_24h", "config", false);

            }}
          />
        {:else}
          <Link
            style="margin-top: 15px;"
            iconSize="21px"
            tooltip="Configurar capa"
            iconIos="f7:gear_alt"
            iconAurora="f7:gear_alt"
            iconMd="f7:gear_alt"
            on:click={() => {
              setToolTree("rave_24h", "config", true);

            }}
          />
        {/if}
      {/if}
    </Col>
  </Row>
</Block>
<!--RAVE 24h points-->
                      <!-- Emisiones -->

                      <!-- Profundidad optica de Aerosoles -->
                      <ListItem
                        style="font-size: 93%"
                        title="Profundidad óptica de Aerosoles"
                        name="demo-checkbox"
                      />
                      <Block style="padding: 0px;">
                        <Row noGap>
                          <Col width="85">
                            <ListItem
                              checkbox
                              name="demo-checkbox"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  $statusInteraction[0]["activeLayer"] = 131;
                                } else {
                                  $statusInteraction[0]["activeLayer"] = 0;
                                }
                              }}
                              on:change={() => {
                                addLayerGeneral(131);
                                setLayerProperties(131);
                                setStatus("togle131", false);
                              }}
                              checked={adminOpacity.find(
                                (item) => item.id === 131
                              )["active"]}
                            >
                              <div slot="title">
                                GOES - AOD <br />{dateMosaicos["goes_aod"]}
                              </div>
                              <div slot="root">
                                {#if $statusInteraction[0]["togle131"] && adminOpacity.find((item) => item.id === 131)["active"]}
                                  <ListItem style="left: 30px;">
                                    <Row noGap>
                                      <Col width="10">
                                        <ListItemCell class="width-auto">
                                          <Icon size="21px" ios="f7:sun_min" aurora="f7:sun_min" md="f7:sun_min" />
                                        </ListItemCell>
                                      </Col>
                                      <Col width="60">
                                        <ListItemCell>
                                          <Range
                                            min={0}
                                            max={100}
                                            step={1}
                                            value={$layerProperties.find(
                                              (item) => item.id === 131
                                            )["opacity"]}
                                            label={true}
                                            onRangeChange={(val) => {
                                              onOpacityChange(val, 131);
                                            }}
                                          />
                                        </ListItemCell>
                                      </Col>
                                      <Col width="15">
                                        <ListItemCell class="width-auto flex-shrink-0">
                                          <Icon size="21px" ios="f7:sun_max_fill" aurora="f7:sun_max_fill" md="f7:sun_max_fill" />
                                        </ListItemCell>
                                      </Col>
                                    </Row>
                                  </ListItem>
                                {/if}
                              </div>
                            </ListItem>
                          </Col>
                          <Col width="15">
                            {#if adminOpacity.find((item) => item.id === 131)["active"]}
                              {#if $statusInteraction[0]["togle131"]}
                                <Link
                                  style="margin-top: 15px;"
                                  iconSize="21px"
                                  tooltip="Configurar capa"
                                  iconIos="f7:gear_alt_fill"
                                  iconAurora="f7:gear_alt_fill"
                                  iconMd="f7:gear_alt_fill"
                                  on:click={() => {
                                    setLayerProperties2(131, "myselect");
                                    setStatus("togle131", false);
                                  }}
                                />
                              {:else}
                                <Link
                                  style="margin-top: 15px;"
                                  iconSize="21px"
                                  tooltip="Configurar capa"
                                  iconIos="f7:gear_alt"
                                  iconAurora="f7:gear_alt"
                                  iconMd="f7:gear_alt"
                                  on:click={() => {
                                    setLayerProperties2(131, "myselect");
                                    setStatus("togle131", true);
                                  }}
                                />
                              {/if}
                            {/if}
                          </Col>
                        </Row>
                      </Block>
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    class="badgeAnalisis"
                    accordionItem
                    accordionItemOpened={accordionOpened["analisis"]}
                    on:accordionOpen={async () => {
                      menuHeightList("analisis", true);
                      let services = [
                        getDateMosaico({ name: "pressure" }),
                      ];
                      let getInfo = await Promise.allSettled(services);
                      let pressure = getInfo[0]["value"];

                      dateMosaicos["pressure"] = moment(
                        pressure["date"]
                        ).format("YYYY");

                      accordionOpened["analisis"] = true;
                    }}
                    on:accordionClose={() => {
                      menuHeightList("analisis", false);
                      accordionOpened["analisis"] = false;
                    }}
                  >
                    <div slot="title">Análisis</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$treeTools.filter(
                          (item) =>
                            item.selected === true && item.group === 'analisis'
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$treeTools.filter(
                          (item) =>
                            item.selected === true && item.group === "analisis"
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="analisis">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <!--Estadísticas (Story maps)-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                on:change={() => {}}
                                onChange={async (e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 50;
                                    addLayerTvector2("estados", 50, "analisis");
                                    setToolsMap("statusEstados", true);
                                    onStoryMaps();
                                    onChangePais();
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    deleteLayerTvector2("estados");
                                    deleteIdentify();
                                    console.log('identify...delete')
                                  }
                                }}
                                checked={$treeTools.find(
                                  (item) => item.id === 50
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 50)[
                                      "selected"
                                    ]
                                  : false}
                              >
                                <div slot="title">
                                  Estadísticas<br
                                  />{$annioBase2}/{$sensorBase2}/{$pcFiltroBase2 ===
                                  "pcalor"
                                    ? "Todos"
                                    : $pcFiltroBase2}<br />{$panelInfo2[
                                    "ref3"
                                  ] === undefined
                                    ? "México"
                                    : $panelInfo2["ref3"]
                                        .charAt(0)
                                        .toUpperCase() +
                                      $panelInfo2["ref3"].slice(1)}
                                </div>
                                <div slot="root">
                                  <!--{#if $treeTools.find(item =>item.id===50)!==undefined?$treeTools.find(item =>item.id===50)['selected']:false}
                              {#if $treeTools.find(item =>item.id===50)['config']} -->

                                  <div
                                    style="visibility: {$treeTools.find(
                                      (item) => item.id === 50
                                    ) !== undefined
                                      ? $treeTools.find(
                                          (item) => item.id === 50
                                        )['selected']
                                        ? 'visible'
                                        : 'hidden'
                                      : 'hidden'};"
                                  >
                                    {#if $storyStatus["filter"] && $treeTools.find((item) => item.id === 50)["selected"]}
                                      <Chip
                                        style="left: 70px;"
                                        deleteable
                                        onDelete={() => {
                                          $storyStatus["filter"] = false;
                                          setToolsMap(
                                            "statusMunicipios",
                                            false
                                          );
                                          onResetStory("2026", "1");
                                        }}
                                      >
                                        <div
                                          slot="text"
                                          style="font-size: 11px;"
                                        >
                                          Eliminar filtro
                                        </div>
                                      </Chip>
                                    {/if}
                                  </div>
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 50) !== undefined ? $treeTools.find((item) => item.id === 50)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 50)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("estados", "identify", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("estados", "identify", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 50) !== undefined ? $treeTools.find((item) => item.id === 50)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 50)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Filtros"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("estados", "config", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Filtros"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("estados", "config", true);

                                      toolsAnalisis = true;
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Índice de Amenaza-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 19;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(19);
                                  setLayerProperties(19);
                                  setStatus("togle19", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 19
                                )["active"]}
                              >
                                <div slot="title">
                                  Índice de Amenaza<br />de Biodiversidad
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle19"] && adminOpacity.find((item) => item.id === 19)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 19
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 19);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 19)["active"]}
                                {#if $statusInteraction[0]["togle19"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(19, "myselect");
                                      setStatus("togle19", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(19, "myselect");
                                      setStatus("togle19", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!-- Presion del Fuego-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 122;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(122);
                                  setLayerProperties(122);
                                  setStatus("togle122", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 122
                                )["active"]}
                              >
                                <div slot="title">
                                  Presión del fuego<br />2000 - {dateMosaicos["pressure"]}
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle122"] && adminOpacity.find((item) => item.id === 122)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 122
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 122);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 122)["active"]}
                                {#if $statusInteraction[0]["togle122"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(122, "myselect");
                                      setStatus("togle122", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(122, "myselect");
                                      setStatus("togle122", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Áreas prioritarias-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                disabled={false}
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 24;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(24);
                                  setLayerProperties(24);
                                  setStatus("togle24", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 24
                                )["active"]}
                              >
                                <div slot="title">
                                  Áreas prioritarias de<br />protección contra<br
                                  />incendios forestales
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle24"] && adminOpacity.find((item) => item.id === 24)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 24
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 24);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 24)["active"]}
                                {#if $statusInteraction[0]["togle24"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(24, "myselect");
                                      setStatus("togle24", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(24, "myselect");
                                      setStatus("togle24", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    class="badgeComplementaria"
                    accordionItem
                    on:accordionOpen={() => {
                      menuHeightList("complementaria", true);
                    }}
                    on:accordionClose={() => {
                      menuHeightList("complementaria", false);
                    }}
                  >
                    <div slot="title">Cartografía complementaria</div>
                    <span slot="after">
                      <Badge
                        color="blue"
                        style="opacity:.8;{$layerProperties.filter(
                          (item) =>
                            item.subgrupo === 'complementaria' && item.active
                        ).length > 0
                          ? ''
                          : 'visibility: hidden'}"
                      >
                        {$layerProperties.filter(
                          (item) =>
                            item.subgrupo === "complementaria" && item.active
                        ).length}
                      </Badge>
                    </span>
                    <AccordionContent id="complementaria">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <!--Cobertura de suelo-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 18;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(18);
                                  setLayerProperties(18);
                                  setStatus("togle18", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 18
                                )["active"]}
                              >
                                <div slot="title">Cobertura de suelo</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle18"] && adminOpacity.find((item) => item.id === 18)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 18
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 18);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 18)["active"]}
                                {#if $statusInteraction[0]["togle18"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(18, "myselect");
                                      setStatus("togle18", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(18, "myselect");
                                      setStatus("togle18", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Luces Estables México-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 20;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(20);
                                  setLayerProperties(20);
                                  setStatus("togle20", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 20
                                )["active"]}
                              >
                                <div slot="title">Luces Estables México</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle20"] && adminOpacity.find((item) => item.id === 20)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 20
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 20);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 20)["active"]}
                                {#if $statusInteraction[0]["togle20"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(20, "myselect");
                                      setStatus("togle20", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(20, "myselect");
                                      setStatus("togle20", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Luces Estables CA-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 21;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(21);
                                  setLayerProperties(21);
                                  setStatus("togle21", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 21
                                )["active"]}
                              >
                                <div slot="title">Luces Estables CA</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle21"] && adminOpacity.find((item) => item.id === 21)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 21
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 21);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 21)["active"]}
                                {#if $statusInteraction[0]["togle21"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(21, "myselect");
                                      setStatus("togle21", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(21, "myselect");
                                      setStatus("togle21", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Áreas Naturales Protegidas-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="75">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addLayerTvector2(
                                      "anp",
                                      22,
                                      "complementaria"
                                    );
                                    $statusInteraction[0]["activeLayer"] = 22;
                                    setLayerProperties3(22, "active", true);
                                  } else {
                                    deleteLayerTvector2("anp");
                                    $statusInteraction[0]["activeLayer"] = 0;
                                    setLayerProperties3(22, "active", false);
                                  }
                                }}
                                on:change={() => {}}
                                checked={$treeTools.find(
                                  (item) => item.id === 22
                                ) !== undefined
                                  ? $treeTools.find((item) => item.id === 22)[
                                      "selected"
                                    ]
                                  : false}
                              >
                                <div slot="title">
                                  Áreas Naturales<br />Protegidas (ANP)
                                </div>
                                <div slot="root">
                                  {#if $treeTools.find((item) => item.id === 22) !== undefined ? $treeTools.find((item) => item.id === 22)["selected"] : false}
                                    {#if $treeTools.find((item) => item.id === 22)["config"]}
                                      <ListItem style="left: 30px;">
                                        <Row noGap>
                                          <Col width="10">
                                            <ListItemCell class="width-auto">
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_min"
                                                aurora="f7:sun_min"
                                                md="f7:sun_min"
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="60">
                                            <ListItemCell>
                                              <Range
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={$layerProperties.find(
                                                  (item) => item.id === 22
                                                )["opacity"]}
                                                label={true}
                                                onRangeChange={(val) => {
                                                  onOpacityChange(val, 22);
                                                }}
                                              />
                                            </ListItemCell>
                                          </Col>
                                          <Col width="15">
                                            <ListItemCell
                                              class="width-auto flex-shrink-0"
                                            >
                                              <Icon
                                                size="21px"
                                                ios="f7:sun_max_fill"
                                                aurora="f7:sun_max_fill"
                                                md="f7:sun_max_fill"
                                              />
                                            </ListItemCell>
                                          </Col>
                                        </Row>
                                      </ListItem>
                                    {/if}
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="10">
                              {#if $treeTools.find((item) => item.id === 22) !== undefined ? $treeTools.find((item) => item.id === 22)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 22)["identify"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle_fill"
                                    iconAurora="f7:info_circle_fill"
                                    iconMd="f7:info_circle_fill"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("anp", "identify", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Identificar objetos espaciales"
                                    iconIos="f7:info_circle"
                                    iconAurora="f7:info_circle"
                                    iconMd="f7:info_circle"
                                    on:click={() => {
                                      deleteIdentify();
                                      setToolTree("anp", "identify", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                            <Col width="15">
                              {#if $treeTools.find((item) => item.id === 22) !== undefined ? $treeTools.find((item) => item.id === 22)["selected"] : false}
                                {#if $treeTools.find((item) => item.id === 22)["config"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setToolTree("anp", "config", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setToolTree("anp", "config", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>

                        <!--Centros Regionales-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 23;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(23);
                                  setLayerProperties(23);
                                  setStatus("togle23", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 23
                                )["active"]}
                              >
                                <div slot="title">Centros Regionales</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle23"] && adminOpacity.find((item) => item.id === 23)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 23
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 23);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 23)["active"]}
                                {#if $statusInteraction[0]["togle23"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(23, "myselect");
                                      setStatus("togle23", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(23, "myselect");
                                      setStatus("togle23", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Frontera de estados-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 25;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(25);
                                  setLayerProperties(25);
                                  setStatus("togle25", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 25
                                )["active"]}
                              >
                                <div slot="title">Frontera de estados</div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle25"] && adminOpacity.find((item) => item.id === 25)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 25
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 25);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 25)["active"]}
                                {#if $statusInteraction[0]["togle25"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(25, "myselect");
                                      setStatus("togle25", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(25, "myselect");
                                      setStatus("togle25", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                        <!--Ejemplo Calles (ESRI Transportation)-->
                        <Block style="padding: 0px;">
                          <Row noGap>
                            <Col width="85">
                              <ListItem
                                checkbox
                                name="demo-checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    $statusInteraction[0]["activeLayer"] = 40;
                                  } else {
                                    $statusInteraction[0]["activeLayer"] = 0;
                                  }
                                }}
                                on:change={() => {
                                  addLayerGeneral(40);
                                  setLayerProperties(40);
                                  setStatus("togle40", false);
                                }}
                                checked={adminOpacity.find(
                                  (item) => item.id === 40
                                )["active"]}
                              >
                                <div slot="title">
                                  Calles (ESRI Transportation)
                                </div>
                                <div slot="root">
                                  {#if $statusInteraction[0]["togle40"] && adminOpacity.find((item) => item.id === 40)["active"]}
                                    <ListItem style="left: 30px;">
                                      <Row noGap>
                                        <Col width="10">
                                          <ListItemCell class="width-auto">
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_min"
                                              aurora="f7:sun_min"
                                              md="f7:sun_min"
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="60">
                                          <ListItemCell>
                                            <Range
                                              min={0}
                                              max={100}
                                              step={1}
                                              value={$layerProperties.find(
                                                (item) => item.id === 40
                                              )["opacity"]}
                                              label={true}
                                              onRangeChange={(val) => {
                                                onOpacityChange(val, 40);
                                              }}
                                            />
                                          </ListItemCell>
                                        </Col>
                                        <Col width="15">
                                          <ListItemCell
                                            class="width-auto flex-shrink-0"
                                          >
                                            <Icon
                                              size="21px"
                                              ios="f7:sun_max_fill"
                                              aurora="f7:sun_max_fill"
                                              md="f7:sun_max_fill"
                                            />
                                          </ListItemCell>
                                        </Col>
                                      </Row>
                                    </ListItem>
                                  {/if}
                                </div>
                              </ListItem>
                            </Col>
                            <Col width="15">
                              {#if adminOpacity.find((item) => item.id === 40)["active"]}
                                {#if $statusInteraction[0]["togle40"]}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt_fill"
                                    iconAurora="f7:gear_alt_fill"
                                    iconMd="f7:gear_alt_fill"
                                    on:click={() => {
                                      setLayerProperties2(40, "myselect");
                                      setStatus("togle40", false);
                                    }}
                                  />
                                {:else}
                                  <Link
                                    style="margin-top: 15px;"
                                    iconSize="21px"
                                    tooltip="Configurar capa"
                                    iconIos="f7:gear_alt"
                                    iconAurora="f7:gear_alt"
                                    iconMd="f7:gear_alt"
                                    on:click={() => {
                                      setLayerProperties2(40, "myselect");
                                      setStatus("togle40", true);
                                    }}
                                  />
                                {/if}
                              {/if}
                            </Col>
                          </Row>
                        </Block>
                      </List>
                    </AccordionContent>
                  </ListItem>
                {/if}
                {#if temas === "consulta"}
                  <ListItem
                    id="menuConsulta"
                    class="badgeFiltro"
                    accordionItem
                    title="Puntos de calor (*Tres meses)"
                    on:accordionOpen={() => {
                      menuHeightList("consulta", true);
                    }}
                    on:accordionClose={() => {
                      menuHeightList("consulta", false);
                    }}
                    badgeColor="#007aff"
                    badge={(function () {
                      let total = $layerProperties.filter(
                        (item) =>
                          item.group === "filtro" &&
                          item.subgrupo === "pcalor" &&
                          item.active
                      ).length;
                      if (total > 0) {
                        setStatus("badge6", true);
                      } else {
                        setStatus("badge6", false);
                      }
                      return total;
                    })()}
                  >
                    <AccordionContent id="consulta">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <Row>
                          <Col width="20" />
                          <Col width="60">
                            <ListInput
                              label="Fecha de inicio:"
                              type="datepicker"
                              value={pickerDateIni}
                              minDate={new Date("2021-01-01")}
                              placeholder="Please choose..."
                              calendarParams={{
                                openIn: "customModal",
                                header: true,
                                headerPlaceholder: "seleccionar fecha...",
                                footer: true,
                                dateFormat: "dd/mm/yyyy",
                                toolbarCloseText: "Asignar",
                                disabled: function (date) {
                                  if (
                                    date <= new Date("2000-01-01") ||
                                    date >= new Date()
                                  ) {
                                    return true;
                                  } else {
                                    return false;
                                  }
                                },
                                on: {
                                  opened: function () {
                                    layerFilter = false;
                                    changeFilter({
                                      dateIni: formatDate(
                                        new Date("2020-04-13")
                                      ),
                                      dateEnd: formatDate(
                                        new Date("2020-04-13")
                                      ),
                                    });
                                  },
                                  change: function (value) {
                                    dateIni = new Date(value["value"]);
                                    pickerDateIni[0] = new Date(value["value"]);
                                    pickerDateEnd = [new Date(value["value"])];
                                    setDate(
                                      "dateIni",
                                      new Date(value["value"])
                                    );
                                  },
                                },
                              }}
                            />
                          </Col>
                          <Col width="20" />
                        </Row>
                        <Row>
                          <Col width="20" />
                          <Col width="60">
                            <ListInput
                              label="Fecha de término:"
                              type="datepicker"
                              value={pickerDateEnd}
                              placeholder="Please choose..."
                              calendarParams={{
                                openIn: "customModal",
                                header: true,
                                headerPlaceholder: "seleccionar fecha...",
                                footer: true,
                                dateFormat: "dd/mm/yyyy",
                                toolbarCloseText: "Asignar",
                                disabled: function (date) {
                                  if (
                                    date <= dateIni ||
                                    date >= moment(dateIni).add(3, "month") ||
                                    date >= new Date()
                                  ) {
                                    return true;
                                  } else {
                                    return false;
                                  }
                                },
                                on: {
                                  opened: function () {
                                    layerFilter = false;
                                    changeFilter({
                                      dateIni: formatDate(
                                        new Date("2020-04-13")
                                      ),
                                      dateEnd: formatDate(
                                        new Date("2020-04-13")
                                      ),
                                    });
                                  },
                                  change: function (value) {
                                    dateEnd = new Date(value["value"]);
                                    pickerDateEnd[0] = new Date(value["value"]);
                                    setDate(
                                      "dateEnd",
                                      new Date(value["value"])
                                    );
                                  },
                                },
                              }}
                            />
                          </Col>
                          <Col width="20" />
                        </Row>
                        <Row>
                          <Col />
                          <Col>
                            <Segmented tag="p">
                              <Button
                                id="filtro3meses"
                                style="height: 24px;width: 77px;font-size: 93%;opacity:0.8;"
                                outline
                                active
                                on:click={() => {
                                  addLayerFilter(pickerDateIni, pickerDateEnd);
                                  addLayerTvector3(
                                    "pcalorFiltro",
                                    32,
                                    "consulta"
                                  );
                                  deleteIdentify();
                                  $statusInteraction[0]["activeLayer"] = 32;
                                  setLayerProperties3(32, "active", true);
                                  layerFilter = true;
                                }}>Filtrar</Button
                              >
                            </Segmented>
                          </Col>
                          <Col>
                            <Segmented tag="p" />
                          </Col>
                        </Row>
                        {#if layerFilter}
                          <Block style="padding: 0px;">
                            <Row noGap>
                              <Col width="75">
                                <ListItem
                                  checkbox
                                  title=""
                                  subtitle=""
                                  name="demo-checkbox"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFilterVisibility(true);
                                      addLayerTvector3(
                                        "pcalorFiltro",
                                        32,
                                        "consulta"
                                      );
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 32;
                                      setLayerProperties3(32, "active", true);
                                    } else {
                                      setFilterVisibility(false);
                                      deleteLayerTvector3("pcalorFiltro");
                                      deleteIdentify();
                                      $statusInteraction[0]["activeLayer"] = 0;
                                      setLayerProperties3(32, "active", false);
                                    }
                                  }}
                                  checked={$treeTools.find(
                                    (item) => item.id === 32
                                  ) !== undefined
                                    ? $treeTools.find((item) => item.id === 32)[
                                        "selected"
                                      ]
                                      ? true
                                      : false
                                    : false}
                                >
                                  <div slot="title">
                                    Filtro (Puntos de calor)
                                  </div>
                                  <div slot="subtitle">
                                    {`${formatDate(dateIni)} - ${formatDate(
                                      dateEnd
                                    )}`}
                                  </div>
                                  <div slot="root">
                                    {#if $treeTools.find((item) => item.id === 32) !== undefined ? $treeTools.find((item) => item.id === 32)["selected"] : false}
                                      {#if $treeTools.find((item) => item.id === 32)["config"]}
                                        <ListItem style="left: 30px;">
                                          <Row noGap>
                                            <Col width="10">
                                              <ListItemCell class="width-auto">
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_min"
                                                  aurora="f7:sun_min"
                                                  md="f7:sun_min"
                                                />
                                              </ListItemCell>
                                            </Col>
                                            <Col width="60">
                                              <ListItemCell>
                                                <Range
                                                  min={0}
                                                  max={100}
                                                  step={1}
                                                  value={100}
                                                  label={true}
                                                  onRangeChange={(val) => {
                                                    setFilterOpacity(val / 100);
                                                  }}
                                                />
                                              </ListItemCell>
                                            </Col>
                                            <Col width="15">
                                              <ListItemCell
                                                class="width-auto flex-shrink-0"
                                              >
                                                <Icon
                                                  iconSize="21px"
                                                  ios="f7:sun_max_fill"
                                                  aurora="f7:sun_max_fill"
                                                  md="f7:sun_max_fill"
                                                />
                                              </ListItemCell>
                                            </Col>
                                          </Row>
                                        </ListItem>
                                      {/if}
                                    {/if}
                                  </div>
                                </ListItem>
                              </Col>
                              <Col width="10">
                                {#if $treeTools.find((item) => item.id === 32) !== undefined ? $treeTools.find((item) => item.id === 32)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 32)["identify"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle_fill"
                                      iconAurora="f7:info_circle_fill"
                                      iconMd="f7:info_circle_fill"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "pcalorFiltro",
                                          "identify",
                                          false
                                        );
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Identificar objetos espaciales"
                                      iconIos="f7:info_circle"
                                      iconAurora="f7:info_circle"
                                      iconMd="f7:info_circle"
                                      on:click={() => {
                                        deleteIdentify();
                                        setToolTree(
                                          "pcalorFiltro",
                                          "identify",
                                          true
                                        );
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                              <Col width="15">
                                {#if $treeTools.find((item) => item.id === 32) !== undefined ? $treeTools.find((item) => item.id === 32)["selected"] : false}
                                  {#if $treeTools.find((item) => item.id === 32)["config"]}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt_fill"
                                      iconAurora="f7:gear_alt_fill"
                                      iconMd="f7:gear_alt_fill"
                                      on:click={() => {
                                        setToolTree(
                                          "pcalorFiltro",
                                          "config",
                                          false
                                        );
                                      }}
                                    />
                                  {:else}
                                    <Link
                                      style="margin-top: 15px;"
                                      iconSize="21px"
                                      tooltip="Configurar capa"
                                      iconIos="f7:gear_alt"
                                      iconAurora="f7:gear_alt"
                                      iconMd="f7:gear_alt"
                                      on:click={() => {
                                        setToolTree(
                                          "pcalorFiltro",
                                          "config",
                                          true
                                        );
                                      }}
                                    />
                                  {/if}
                                {/if}
                              </Col>
                            </Row>
                          </Block>
                        {/if}
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    accordionItem
                    class="badgeHistorico"
                    title="Datos históricos mensuales"
                    badgeColor="#007aff"
                    badge={(function () {
                      let total = 0;
                      if (
                        $treeTools.find((item) => item.selected === true) !==
                        undefined
                      ) {
                        total =
                          $treeTools.filter((item) => item.selected === true)
                            .length - 1;
                      }
                      if (total > 0) {
                        setStatus("badge9", true);
                      } else {
                        setStatus("badge9", false);
                      }
                      return total;
                    })()}
                    on:accordionOpen={() => {
                      setTimeout(function () {
                        menuHeightList("historicoConsulta", true);
                        scroll = "auto";

                      }, 200);
                    }}
                    on:accordionClose={() => {
                      menuHeightList("historicoConsulta", false);
                    }}
                  >
                    <AccordionContent id="historicoConsulta">
                      <List mediaList style="font-size: 93%;margin-left: 15px;">
                        <TreeView
                          on:message={(evt) => {
                            //menu_prueba
                            let menuPruebaHeight = document.querySelector(`#menu_prueba`).offsetHeight
                            console.log(menuPruebaHeight,'menuPruebaHeight...')
                            innerHeightBase = innerHeight - 220;
                            
                          }}
                          {tree}
                        />
                      </List>
                    </AccordionContent>
                  </ListItem>
                {/if}
                {#if temas === "descargas"}
                  <ListItem
                    accordionItem
                    title="Puntos de calor"
                    badgeColor="#007aff"
                    on:accordionOpen={() => {
                      menuHeightList("pcalorDescargas", true);
                      scroll = "auto";
                    }}
                    on:accordionClose={() => {
                      menuHeightList('pcalorDescargas',false)
                      scroll = "hidden";
                      innerHeightBase = 146;
                    }}
                  >
                    <AccordionContent id="pcalorDescargas">
                      <AdminExport />
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    accordionItem
                    title="Datos históricos"
                    badgeColor="#007aff"
                    on:accordionOpen={() => {
                      menuHeightList("dHistoricos", true);
                    }}
                    on:accordionClose={() => {
                      menuHeightList("dHistoricos", false);
                    }}
                  >
                    <AccordionContent id="dHistoricos">
                      <List mediaList style="font-size: 93%;margin-left: 5px;">
                        <ListInput
                          label="Información"
                          type="select"
                          bind:value={selectedInfo}
                          placeholder="Selecciona..."
                        >
                          <i class="icon demo-list-icon" slot="media" />
                          <option value="hotspots/puntosCalor"
                            >Puntos de calor</option
                          >
                          <option value="burnscar/burnscar"
                            >Áreas quemadas</option
                          >
                        </ListInput>
                        <ListInput
                          label="Año"
                          type="select"
                          bind:value={selectedYear}
                          placeholder="Selecciona..."
                        >
                          <i class="icon demo-list-icon" slot="media" />
                          {#each yearGroup as item}
                            <option value={item} selected>{item}</option>
                          {/each}
                        </ListInput>
                        <ListInput
                          label="Mes"
                          type="select"
                          bind:value={selectedMonth}
                          placeholder="Selecciona..."
                        >
                          <i class="icon demo-list-icon" slot="media" />
                          <option value="01">Enero</option>
                          <option value="02">Febrero</option>
                          <option value="03">Marzo</option>
                          <option value="04">Abril</option>
                          <option value="05">Mayo</option>
                          <option value="06">Junio</option>
                          <option value="07">Julio</option>
                          <option value="08">Agosto</option>
                          <option value="09">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </ListInput>
                        <Row>
                          <Col />
                          <Col>
                            <Segmented tag="p">
                              <Button
                                external
                                href="http://terra2.conabio.gob.mx/historico/{selectedInfo}_{selectedYear}_{selectedMonth}.zip"
                                style="height: 24px;width: 87px;font-size: 93%;"
                                outline
                                active>Descargar</Button
                              >
                            </Segmented>
                          </Col>
                          <Col />
                        </Row>
                      </List>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    accordionItem
                    title="Herramientas"
                    badgeColor="#007aff"
                    on:accordionOpen={() => {
                      menuHeightList("herramientas", true);
                      scroll = "auto";
                    }}
                    on:accordionClose={() => {
                      menuHeightList("herramientas", false);
                      scroll = "hidden";
                      innerHeightBase = 146;
                    }}
                  >
                    <AccordionContent id="herramientas">
                      <ListItem
                        style="margin-left: 15px;"
                        accordionItem
                        title="Áreas quemadas de Landsat"
                        badgeColor="#007aff"
                      >
                        <AccordionContent>
                          <Card class="demo-card-header-pic">
                            <CardHeader
                              class="no-border"
                              valign="bottom"
                              style=""
                              >Plugin para QGIS: BurnedArea from Landsat 8</CardHeader
                            >
                            <CardContent>
                              <p>
                                El plugin estima áreas quemadas de imágenes
                                Landsat 8 OLI, las escenas pre y post al
                                incendio son requeridas.
                              </p>
                              <p>
                                Calcula los indices : NBR, NDVI y dNBR Indices
                                opcionales: IAQ, RdNBR
                              </p>
                              <p class="likes">
                                Contacto: premota@conabio.gob.mx
                              </p>
                            </CardContent>
                            <CardFooter>
                              <Link
                                href="http://terra2.conabio.gob.mx/historico/pluginQGIS/Plugin_QGIS_w64_v.1.21.zip"
                                external>Plugin QGIS para windows</Link
                              >
                            </CardFooter>
                          </Card>
                        </AccordionContent>
                      </ListItem>
                    </AccordionContent>
                  </ListItem>
                {/if}
              </List>
            </div>
          </Col>
        </Row>
      </Block>
    {/if}
  </Page>
</div>

<style>
  :root {
    --f7-calendar-picker-bg-color: white;
    --f7-calendar-time-selector-bg-color: blue;
    --f7-list-item-padding-vertical: 1px;
  }
  /*.mapboxgl-ctrl-top-left,
.mapboxgl-ctrl-top-right,
.mapboxgl-ctrl-bottom-left,
.mapboxgl-ctrl-bottom-right {
    position: absolute;
    pointer-events: none;
    z-index: 2;
}*/
  /*.mapboxgl-popup {
    max-width: 200px;
  }*/
  /*.mapboxgl-popup-content {
    text-align: center;
    font-family: "Open Sans", sans-serif;
    color: "var(--f7-list-item-title-text-color)";
  }*/
  .identify {
    border-radius: 3px;
    bottom: 50px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
    padding: 10px;
    position: absolute;
    right: 130px;
    z-index: 1;
    opacity: 0.7;
    background: var(--f7-list-bg-color);
  }
  .identify div span {
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }
  .legend {
    border-radius: 3px;
    bottom: 55px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
    padding: 10px;
    position: absolute;
    right: 10px;
    z-index: 1;
    opacity: 0.7;
  }
  .legend h4 {
    margin: 0 0 10px;
  }
  .legend div span {
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-right: 5px;
    width: 10px;
  }
  .legend .legend-gradient {
    height: 12px;
    width: 100%;
    min-width: 140px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .legend .legend-gradient-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 2px;
    font-size: 11px;
  }
  /*.legend-control {
    border-radius: 3px;
    bottom: 50px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
    padding: 10px;
    position: absolute;
    right: 65px;
    z-index: 1;
    opacity: 0.7;
    background: var(--f7-list-bg-color);
  }*/

  /*.mapboxgl-ctrl-group button.mapbox-gl-draw_polygon .mapboxgl-ctrl-icon {
    background-repeat: no-repeat;
    background-position: center;
    pointer-events: auto;
    background-image: url(data:image/svg+xml;base64,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);
  }*/
</style>
